var map = {
	"./admin": 611,
	"./admin/": 611,
	"./admin/components/AnalysisBlock": 1332,
	"./admin/components/AnalysisBlock.js": 1332,
	"./admin/components/Avatar": 167,
	"./admin/components/Avatar.js": 167,
	"./admin/components/Avatars": 359,
	"./admin/components/Avatars.js": 359,
	"./admin/components/BlockList": 322,
	"./admin/components/BlockList/": 322,
	"./admin/components/BlockList/Block": 589,
	"./admin/components/BlockList/Block.js": 589,
	"./admin/components/BlockList/index": 322,
	"./admin/components/BlockList/index.js": 322,
	"./admin/components/ButtonReport": 497,
	"./admin/components/ButtonReport.js": 497,
	"./admin/components/ButtonSetting": 362,
	"./admin/components/ButtonSetting.js": 362,
	"./admin/components/ClassroomBlockList": 424,
	"./admin/components/ClassroomBlockList/": 424,
	"./admin/components/ClassroomBlockList/index": 424,
	"./admin/components/ClassroomBlockList/index.js": 424,
	"./admin/components/Container": 210,
	"./admin/components/Container.js": 210,
	"./admin/components/Divider": 253,
	"./admin/components/Divider.js": 253,
	"./admin/components/DropzoneWithState": 503,
	"./admin/components/DropzoneWithState.js": 503,
	"./admin/components/EstablishmentBlockList": 422,
	"./admin/components/EstablishmentBlockList/": 422,
	"./admin/components/EstablishmentBlockList/index": 422,
	"./admin/components/EstablishmentBlockList/index.js": 422,
	"./admin/components/EstablishmentList": 588,
	"./admin/components/EstablishmentList.js": 588,
	"./admin/components/EstablishmentListTitle": 714,
	"./admin/components/EstablishmentListTitle.js": 714,
	"./admin/components/ExpandDropdown": 1070,
	"./admin/components/ExpandDropdown.js": 1070,
	"./admin/components/ExpandIcons": 587,
	"./admin/components/ExpandIcons.js": 587,
	"./admin/components/ExpandRow": 707,
	"./admin/components/ExpandRow.js": 707,
	"./admin/components/Header": 270,
	"./admin/components/Header.js": 270,
	"./admin/components/IconButton": 499,
	"./admin/components/IconButton.js": 499,
	"./admin/components/InputSearch": 696,
	"./admin/components/InputSearch.js": 696,
	"./admin/components/ModalAnonymiseUsers": 501,
	"./admin/components/ModalAnonymiseUsers.js": 501,
	"./admin/components/ModalConfirmation": 715,
	"./admin/components/ModalConfirmation.js": 715,
	"./admin/components/ModalContainer": 1333,
	"./admin/components/ModalContainer.js": 1333,
	"./admin/components/ModalDeleteConfirmation": 363,
	"./admin/components/ModalDeleteConfirmation.js": 363,
	"./admin/components/Pagination": 697,
	"./admin/components/Pagination.js": 697,
	"./admin/components/PopoverAvatar": 1072,
	"./admin/components/PopoverAvatar.js": 1072,
	"./admin/components/PrevNextLinks": 962,
	"./admin/components/PrevNextLinks.js": 962,
	"./admin/components/Select": 396,
	"./admin/components/Select.js": 396,
	"./admin/components/SortStatus": 699,
	"./admin/components/SortStatus.js": 699,
	"./admin/components/Table": 182,
	"./admin/components/Table.js": 182,
	"./admin/components/TableHeader": 211,
	"./admin/components/TableHeader.js": 211,
	"./admin/components/TableTitle": 698,
	"./admin/components/TableTitle.js": 698,
	"./admin/components/Tabs": 179,
	"./admin/components/Tabs/": 179,
	"./admin/components/Tabs/index": 179,
	"./admin/components/Tabs/index.js": 179,
	"./admin/components/UserList": 166,
	"./admin/components/UserList/": 166,
	"./admin/components/UserList/components/CellEmail": 621,
	"./admin/components/UserList/components/CellEmail.js": 621,
	"./admin/components/UserList/components/CellFullName": 622,
	"./admin/components/UserList/components/CellFullName.js": 622,
	"./admin/components/UserList/components/CellFullNameWithEmail": 418,
	"./admin/components/UserList/components/CellFullNameWithEmail.js": 418,
	"./admin/components/UserList/components/cellPropTypes": 360,
	"./admin/components/UserList/components/cellPropTypes.js": 360,
	"./admin/components/UserList/index": 166,
	"./admin/components/UserList/index.js": 166,
	"./admin/components/UserListTitle": 704,
	"./admin/components/UserListTitle.js": 704,
	"./admin/containers/Class": 626,
	"./admin/containers/Class/": 626,
	"./admin/containers/Class/Lecturers": 964,
	"./admin/containers/Class/Lecturers.js": 964,
	"./admin/containers/Class/SectionsSettings": 965,
	"./admin/containers/Class/SectionsSettings.js": 965,
	"./admin/containers/Class/index": 626,
	"./admin/containers/Class/index.js": 626,
	"./admin/containers/CreateClass/ModalClassSettings": 500,
	"./admin/containers/CreateClass/ModalClassSettings.js": 500,
	"./admin/containers/CreateClass/ModalCreateClass": 701,
	"./admin/containers/CreateClass/ModalCreateClass.js": 701,
	"./admin/containers/CreateClass/StepOne": 703,
	"./admin/containers/CreateClass/StepOne.js": 703,
	"./admin/containers/CreateClass/StepTitle": 705,
	"./admin/containers/CreateClass/StepTitle.js": 705,
	"./admin/containers/CreateClass/StepTwo": 706,
	"./admin/containers/CreateClass/StepTwo.js": 706,
	"./admin/containers/CreateClass/Steps": 702,
	"./admin/containers/CreateClass/Steps.js": 702,
	"./admin/containers/CreateLecturer/ModalCreateAdminAndLecturer": 1073,
	"./admin/containers/CreateLecturer/ModalCreateAdminAndLecturer.js": 1073,
	"./admin/containers/Dashboards/BmcDashboard": 425,
	"./admin/containers/Dashboards/BmcDashboard/": 425,
	"./admin/containers/Dashboards/BmcDashboard/BlockSection": 959,
	"./admin/containers/Dashboards/BmcDashboard/BlockSection.js": 959,
	"./admin/containers/Dashboards/BmcDashboard/ModalBMCList/ModalBMCList": 963,
	"./admin/containers/Dashboards/BmcDashboard/ModalBMCList/ModalBMCList.js": 963,
	"./admin/containers/Dashboards/BmcDashboard/index": 425,
	"./admin/containers/Dashboards/BmcDashboard/index.js": 425,
	"./admin/containers/Dashboards/ClassroomDashboard": 423,
	"./admin/containers/Dashboards/ClassroomDashboard/": 423,
	"./admin/containers/Dashboards/ClassroomDashboard/index": 423,
	"./admin/containers/Dashboards/ClassroomDashboard/index.js": 423,
	"./admin/containers/Dashboards/EducatorDashboard": 417,
	"./admin/containers/Dashboards/EducatorDashboard/": 417,
	"./admin/containers/Dashboards/EducatorDashboard/index": 417,
	"./admin/containers/Dashboards/EducatorDashboard/index.js": 417,
	"./admin/containers/Dashboards/EstablishmentDashboard": 393,
	"./admin/containers/Dashboards/EstablishmentDashboard/": 393,
	"./admin/containers/Dashboards/EstablishmentDashboard/index": 393,
	"./admin/containers/Dashboards/EstablishmentDashboard/index.js": 393,
	"./admin/containers/Dashboards/SuperAdminDashboard": 419,
	"./admin/containers/Dashboards/SuperAdminDashboard/": 419,
	"./admin/containers/Dashboards/SuperAdminDashboard/index": 419,
	"./admin/containers/Dashboards/SuperAdminDashboard/index.js": 419,
	"./admin/containers/ElevatedPrivilegesSignup": 421,
	"./admin/containers/ElevatedPrivilegesSignup/": 421,
	"./admin/containers/ElevatedPrivilegesSignup/SingularSignupListItem": 720,
	"./admin/containers/ElevatedPrivilegesSignup/SingularSignupListItem.js": 720,
	"./admin/containers/ElevatedPrivilegesSignup/index": 421,
	"./admin/containers/ElevatedPrivilegesSignup/index.js": 421,
	"./admin/containers/Ideation": 464,
	"./admin/containers/Ideation/": 464,
	"./admin/containers/Ideation/index": 464,
	"./admin/containers/Ideation/index.js": 464,
	"./admin/containers/Lists/AdminLecturerLists": 509,
	"./admin/containers/Lists/AdminLecturerLists.js": 509,
	"./admin/containers/Lists/ClassLists": 358,
	"./admin/containers/Lists/ClassLists.js": 358,
	"./admin/containers/Lists/EstablishmentLists": 716,
	"./admin/containers/Lists/EstablishmentLists.js": 716,
	"./admin/containers/Lists/ProjectLists": 272,
	"./admin/containers/Lists/ProjectLists.js": 272,
	"./admin/containers/Lists/StudentLists": 273,
	"./admin/containers/Lists/StudentLists.js": 273,
	"./admin/containers/Lists/TenantLists": 719,
	"./admin/containers/Lists/TenantLists.js": 719,
	"./admin/containers/ModalBmcTeamMembers": 466,
	"./admin/containers/ModalBmcTeamMembers/": 466,
	"./admin/containers/ModalBmcTeamMembers/index": 466,
	"./admin/containers/ModalBmcTeamMembers/index.js": 466,
	"./admin/containers/ModalEducatorInvites": 420,
	"./admin/containers/ModalEducatorInvites/": 420,
	"./admin/containers/ModalEducatorInvites/index": 420,
	"./admin/containers/ModalEducatorInvites/index.js": 420,
	"./admin/containers/ModalEstablishment/DateRangeComponent": 508,
	"./admin/containers/ModalEstablishment/DateRangeComponent.js": 508,
	"./admin/containers/ModalEstablishment/ModalCreateEstablishment": 717,
	"./admin/containers/ModalEstablishment/ModalCreateEstablishment.js": 717,
	"./admin/containers/ModalEstablishment/ModalUpdateEstablishment": 718,
	"./admin/containers/ModalEstablishment/ModalUpdateEstablishment.js": 718,
	"./admin/containers/ModalUser/ConfirmationAnonymiseModal": 713,
	"./admin/containers/ModalUser/ConfirmationAnonymiseModal.js": 713,
	"./admin/containers/ModalUser/ConfirmationDeleteModal": 505,
	"./admin/containers/ModalUser/ConfirmationDeleteModal.js": 505,
	"./admin/containers/ModalUser/ModalUpdateAdminAndLecturer": 502,
	"./admin/containers/ModalUser/ModalUpdateAdminAndLecturer.js": 502,
	"./admin/containers/Selects/SelectClassroom": 1334,
	"./admin/containers/Selects/SelectClassroom.js": 1334,
	"./admin/containers/Selects/SelectEstablishment": 361,
	"./admin/containers/Selects/SelectEstablishment.js": 361,
	"./admin/containers/Selects/SelectMultipleEstablishments": 506,
	"./admin/containers/Selects/SelectMultipleEstablishments.js": 506,
	"./admin/containers/Selects/SelectUser": 271,
	"./admin/containers/Selects/SelectUser.js": 271,
	"./admin/containers/Tables/ProjectsTable": 708,
	"./admin/containers/Tables/ProjectsTable.js": 708,
	"./admin/index": 611,
	"./admin/index.js": 611,
	"./admin/models/activeUser": 662,
	"./admin/models/activeUser.js": 662,
	"./admin/models/admin": 665,
	"./admin/models/admin.js": 665,
	"./admin/models/adminLecturers": 661,
	"./admin/models/adminLecturers.js": 661,
	"./admin/models/blocks": 657,
	"./admin/models/blocks.js": 657,
	"./admin/models/bmcs": 656,
	"./admin/models/bmcs.js": 656,
	"./admin/models/classroom": 485,
	"./admin/models/classroom.js": 485,
	"./admin/models/classroomLecturer": 654,
	"./admin/models/classroomLecturer.js": 654,
	"./admin/models/classrooms": 655,
	"./admin/models/classrooms.js": 655,
	"./admin/models/elevatedSignupLinks": 667,
	"./admin/models/elevatedSignupLinks.js": 667,
	"./admin/models/establishment": 660,
	"./admin/models/establishment.js": 660,
	"./admin/models/establishments": 659,
	"./admin/models/establishments.js": 659,
	"./admin/models/lecturers": 658,
	"./admin/models/lecturers.js": 658,
	"./admin/models/pagination": 664,
	"./admin/models/pagination.js": 664,
	"./admin/models/students": 663,
	"./admin/models/students.js": 663,
	"./admin/models/tenants": 666,
	"./admin/models/tenants.js": 666,
	"./admin/models/users": 487,
	"./admin/models/users.js": 487,
	"./admin/store": 321,
	"./admin/store/": 321,
	"./admin/store/index": 321,
	"./admin/store/index.js": 321,
	"./admin/support/router": 668,
	"./admin/support/router.js": 668,
	"./admin/support/serverRoutes": 46,
	"./admin/support/serverRoutes.js": 46,
	"./admin/utils/access": 104,
	"./admin/utils/access.js": 104,
	"./admin/utils/const": 398,
	"./admin/utils/const.js": 398,
	"./admin/utils/date": 254,
	"./admin/utils/date.js": 254,
	"./admin/utils/factories": 86,
	"./admin/utils/factories/": 86,
	"./admin/utils/factories/blocks": 584,
	"./admin/utils/factories/blocks.js": 584,
	"./admin/utils/factories/index": 86,
	"./admin/utils/factories/index.js": 86,
	"./admin/utils/helpers": 165,
	"./admin/utils/helpers.js": 165,
	"./admin/utils/icons": 960,
	"./admin/utils/icons.js": 960,
	"./admin/utils/page_names": 507,
	"./admin/utils/page_names.js": 507,
	"./create_first_bmc": 627,
	"./create_first_bmc/": 627,
	"./create_first_bmc/createFirstBmc": 467,
	"./create_first_bmc/createFirstBmc/": 467,
	"./create_first_bmc/createFirstBmc/index": 467,
	"./create_first_bmc/createFirstBmc/index.js": 467,
	"./create_first_bmc/index": 627,
	"./create_first_bmc/index.js": 627,
	"./create_first_bmc/store": 966,
	"./create_first_bmc/store.js": 966,
	"./ideation": 628,
	"./ideation/": 628,
	"./ideation/IdeaCarousel": 969,
	"./ideation/IdeaCarousel.js": 969,
	"./ideation/index": 628,
	"./ideation/index.js": 628,
	"./lib/utils": 494,
	"./lib/utils.js": 494,
	"./main": 629,
	"./main/": 629,
	"./main/components/Actions": 28,
	"./main/components/Actions.js": 28,
	"./main/components/Alert": 285,
	"./main/components/Alert.js": 285,
	"./main/components/Arrows": 536,
	"./main/components/Arrows.js": 536,
	"./main/components/BmcMenu": 749,
	"./main/components/BmcMenu.js": 749,
	"./main/components/BmcMobileMenu": 743,
	"./main/components/BmcMobileMenu.js": 743,
	"./main/components/Button": 16,
	"./main/components/Button.js": 16,
	"./main/components/Checkbox": 590,
	"./main/components/Checkbox.js": 590,
	"./main/components/CloseButton": 740,
	"./main/components/CloseButton.js": 740,
	"./main/components/ConfirmationModal": 35,
	"./main/components/ConfirmationModal.js": 35,
	"./main/components/ConfirmationModalBase": 366,
	"./main/components/ConfirmationModalBase.js": 366,
	"./main/components/ConnectionChecker": 530,
	"./main/components/ConnectionChecker.js": 530,
	"./main/components/DonutChart": 515,
	"./main/components/DonutChart.js": 515,
	"./main/components/Dropzone": 41,
	"./main/components/Dropzone/": 41,
	"./main/components/Dropzone/DropzoneArea": 709,
	"./main/components/Dropzone/DropzoneArea.js": 709,
	"./main/components/Dropzone/DropzoneAreaInner": 1335,
	"./main/components/Dropzone/DropzoneAreaInner.js": 1335,
	"./main/components/Dropzone/DropzoneAreaInnerCurrent": 710,
	"./main/components/Dropzone/DropzoneAreaInnerCurrent.js": 710,
	"./main/components/Dropzone/DropzoneModal": 711,
	"./main/components/Dropzone/DropzoneModal.js": 711,
	"./main/components/Dropzone/DropzoneModalTemplates": 712,
	"./main/components/Dropzone/DropzoneModalTemplates.js": 712,
	"./main/components/Dropzone/index": 41,
	"./main/components/Dropzone/index.js": 41,
	"./main/components/FinanceTabs/ForecastTab": 283,
	"./main/components/FinanceTabs/ForecastTab.js": 283,
	"./main/components/FinanceTabs/GraphTab": 282,
	"./main/components/FinanceTabs/GraphTab.js": 282,
	"./main/components/FinanceTabs/UnitEconomicsTab": 281,
	"./main/components/FinanceTabs/UnitEconomicsTab.js": 281,
	"./main/components/FormInput": 120,
	"./main/components/FormInput.js": 120,
	"./main/components/Header": 26,
	"./main/components/Header.js": 26,
	"./main/components/Icon": 763,
	"./main/components/Icon.js": 763,
	"./main/components/ImageBlock": 926,
	"./main/components/ImageBlock.js": 926,
	"./main/components/ImageDrop/ImageDropCS": 187,
	"./main/components/ImageDrop/ImageDropCS.js": 187,
	"./main/components/ImageDrop/ImageDropChannels": 241,
	"./main/components/ImageDrop/ImageDropChannels.js": 241,
	"./main/components/ImageUploader": 185,
	"./main/components/ImageUploader.js": 185,
	"./main/components/Img": 53,
	"./main/components/Img.js": 53,
	"./main/components/Input": 724,
	"./main/components/Input.js": 724,
	"./main/components/Line": 27,
	"./main/components/Line.js": 27,
	"./main/components/Links": 215,
	"./main/components/Links.js": 215,
	"./main/components/List": 37,
	"./main/components/List.js": 37,
	"./main/components/MobileMenuHeader": 25,
	"./main/components/MobileMenuHeader.js": 25,
	"./main/components/Modal": 54,
	"./main/components/Modal.js": 54,
	"./main/components/NotifySystem": 367,
	"./main/components/NotifySystem.js": 367,
	"./main/components/NumberInput": 115,
	"./main/components/NumberInput.js": 115,
	"./main/components/PortfolioCommentIcon": 33,
	"./main/components/PortfolioCommentIcon.js": 33,
	"./main/components/ProgressBar": 295,
	"./main/components/ProgressBar.js": 295,
	"./main/components/RangeWithInputCurrent": 278,
	"./main/components/RangeWithInputCurrent.js": 278,
	"./main/components/RangeWithInputs": 399,
	"./main/components/RangeWithInputs.js": 399,
	"./main/components/RemoveButton": 1336,
	"./main/components/RemoveButton.js": 1336,
	"./main/components/RouteRedirect": 298,
	"./main/components/RouteRedirect.js": 298,
	"./main/components/ScrollToTop": 493,
	"./main/components/ScrollToTop.js": 493,
	"./main/components/Section": 101,
	"./main/components/Section.js": 101,
	"./main/components/SectionHeader": 39,
	"./main/components/SectionHeader.js": 39,
	"./main/components/SectionHeaderWeb": 40,
	"./main/components/SectionHeaderWeb.js": 40,
	"./main/components/Select": 75,
	"./main/components/Select.js": 75,
	"./main/components/Spinner": 64,
	"./main/components/Spinner.js": 64,
	"./main/components/SvgIcon": 15,
	"./main/components/SvgIcon.js": 15,
	"./main/components/Switcher": 514,
	"./main/components/Switcher.js": 514,
	"./main/components/Tabs": 38,
	"./main/components/Tabs.js": 38,
	"./main/components/TabsCut": 49,
	"./main/components/TabsCut.js": 49,
	"./main/components/TabsHeader": 745,
	"./main/components/TabsHeader.js": 745,
	"./main/components/TabsList": 36,
	"./main/components/TabsList.js": 36,
	"./main/components/TabsListItem": 34,
	"./main/components/TabsListItem.js": 34,
	"./main/components/TabsListTitle": 66,
	"./main/components/TabsListTitle.js": 66,
	"./main/components/Text": 19,
	"./main/components/Text.js": 19,
	"./main/components/Textarea": 13,
	"./main/components/Textarea/": 13,
	"./main/components/Textarea/Status": 723,
	"./main/components/Textarea/Status.js": 723,
	"./main/components/Textarea/TextAreaInput": 722,
	"./main/components/Textarea/TextAreaInput.js": 722,
	"./main/components/Textarea/TextareaDescription": 1337,
	"./main/components/Textarea/TextareaDescription.js": 1337,
	"./main/components/Textarea/index": 13,
	"./main/components/Textarea/index.js": 13,
	"./main/components/Title": 22,
	"./main/components/Title.js": 22,
	"./main/components/UploadFiles": 184,
	"./main/components/UploadFiles.js": 184,
	"./main/components/UploadFinancialFiles": 164,
	"./main/components/UploadFinancialFiles.js": 164,
	"./main/components/UserAvatar": 511,
	"./main/components/UserAvatar.js": 511,
	"./main/containers/Page404": 492,
	"./main/containers/Page404.js": 492,
	"./main/containers/account/Account": 912,
	"./main/containers/account/Account.js": 912,
	"./main/containers/account/Email": 915,
	"./main/containers/account/Email.js": 915,
	"./main/containers/account/Menu": 913,
	"./main/containers/account/Menu.js": 913,
	"./main/containers/account/Password": 914,
	"./main/containers/account/Password.js": 914,
	"./main/containers/account/Personal": 442,
	"./main/containers/account/Personal/": 442,
	"./main/containers/account/Personal/Content": 526,
	"./main/containers/account/Personal/Content.js": 526,
	"./main/containers/account/Personal/index": 442,
	"./main/containers/account/Personal/index.js": 442,
	"./main/containers/account/Section": 284,
	"./main/containers/account/Section.js": 284,
	"./main/containers/actioncable/ActionCableHandler": 942,
	"./main/containers/actioncable/ActionCableHandler.js": 942,
	"./main/containers/actioncable/ChatGroupCableHandler": 695,
	"./main/containers/actioncable/ChatGroupCableHandler.js": 695,
	"./main/containers/actioncable/UserCableHandler": 531,
	"./main/containers/actioncable/UserCableHandler.js": 531,
	"./main/containers/actioncable/portfolioMapping": 943,
	"./main/containers/actioncable/portfolioMapping.js": 943,
	"./main/containers/bmc": 394,
	"./main/containers/bmc/": 394,
	"./main/containers/bmc/BmcCanvas": 146,
	"./main/containers/bmc/BmcCanvas/": 146,
	"./main/containers/bmc/BmcCanvas/BmcCanvasContainer": 1338,
	"./main/containers/bmc/BmcCanvas/BmcCanvasContainer.js": 1338,
	"./main/containers/bmc/BmcCanvas/BmcCanvasSection": 122,
	"./main/containers/bmc/BmcCanvas/BmcCanvasSection.js": 122,
	"./main/containers/bmc/BmcCanvas/Channels": 725,
	"./main/containers/bmc/BmcCanvas/Channels.js": 725,
	"./main/containers/bmc/BmcCanvas/Costs": 734,
	"./main/containers/bmc/BmcCanvas/Costs.js": 734,
	"./main/containers/bmc/BmcCanvas/CustomerRelationships": 726,
	"./main/containers/bmc/BmcCanvas/CustomerRelationships.js": 726,
	"./main/containers/bmc/BmcCanvas/CustomerSegments": 721,
	"./main/containers/bmc/BmcCanvas/CustomerSegments.js": 721,
	"./main/containers/bmc/BmcCanvas/KeyActivities": 730,
	"./main/containers/bmc/BmcCanvas/KeyActivities.js": 730,
	"./main/containers/bmc/BmcCanvas/KeyPartners": 732,
	"./main/containers/bmc/BmcCanvas/KeyPartners.js": 732,
	"./main/containers/bmc/BmcCanvas/KeyResources": 733,
	"./main/containers/bmc/BmcCanvas/KeyResources.js": 733,
	"./main/containers/bmc/BmcCanvas/Revenue": 958,
	"./main/containers/bmc/BmcCanvas/Revenue.js": 958,
	"./main/containers/bmc/BmcCanvas/Sustainabilities": 957,
	"./main/containers/bmc/BmcCanvas/Sustainabilities.js": 957,
	"./main/containers/bmc/BmcCanvas/ValueProposition": 729,
	"./main/containers/bmc/BmcCanvas/ValueProposition.js": 729,
	"./main/containers/bmc/BmcCanvas/index": 146,
	"./main/containers/bmc/BmcCanvas/index.js": 146,
	"./main/containers/bmc/BmcCanvasContainer": 214,
	"./main/containers/bmc/BmcCanvasContainer.js": 214,
	"./main/containers/bmc/BmcList": 738,
	"./main/containers/bmc/BmcList.js": 738,
	"./main/containers/bmc/BmcListCard": 206,
	"./main/containers/bmc/BmcListCard.js": 206,
	"./main/containers/bmc/CardModal": 123,
	"./main/containers/bmc/CardModal.js": 123,
	"./main/containers/bmc/CreateBmcModal": 735,
	"./main/containers/bmc/CreateBmcModal.js": 735,
	"./main/containers/bmc/DeleteBmcOwnerModal": 737,
	"./main/containers/bmc/DeleteBmcOwnerModal.js": 737,
	"./main/containers/bmc/KeyActivityCard": 731,
	"./main/containers/bmc/KeyActivityCard.js": 731,
	"./main/containers/bmc/Menu": 512,
	"./main/containers/bmc/Menu.js": 512,
	"./main/containers/bmc/MobileMenu": 513,
	"./main/containers/bmc/MobileMenu.js": 513,
	"./main/containers/bmc/Team": 510,
	"./main/containers/bmc/Team.js": 510,
	"./main/containers/bmc/TeamMembers": 364,
	"./main/containers/bmc/TeamMembers.js": 364,
	"./main/containers/bmc/UpdateBmcModal": 736,
	"./main/containers/bmc/UpdateBmcModal.js": 736,
	"./main/containers/bmc/UserBar": 354,
	"./main/containers/bmc/UserBar.js": 354,
	"./main/containers/bmc/index": 394,
	"./main/containers/bmc/index.js": 394,
	"./main/containers/channel": 430,
	"./main/containers/channel/": 430,
	"./main/containers/channel/Card": 275,
	"./main/containers/channel/Card.js": 275,
	"./main/containers/channel/CardBlogArch": 195,
	"./main/containers/channel/CardBlogArch.js": 195,
	"./main/containers/channel/CardColourfulBold": 242,
	"./main/containers/channel/CardColourfulBold.js": 242,
	"./main/containers/channel/CardCurrent": 194,
	"./main/containers/channel/CardCurrent.js": 194,
	"./main/containers/channel/CreateYourChannels": 770,
	"./main/containers/channel/CreateYourChannels.js": 770,
	"./main/containers/channel/Intro": 769,
	"./main/containers/channel/Intro.js": 769,
	"./main/containers/channel/Summary": 771,
	"./main/containers/channel/Summary.js": 771,
	"./main/containers/channel/index": 430,
	"./main/containers/channel/index.js": 430,
	"./main/containers/chat": 267,
	"./main/containers/chat/": 267,
	"./main/containers/chat/chat-group/chat-group-container": 672,
	"./main/containers/chat/chat-group/chat-group-container.js": 672,
	"./main/containers/chat/chat-group/chat-group-header-component": 1075,
	"./main/containers/chat/chat-group/chat-group-header-component.js": 1075,
	"./main/containers/chat/chat-group/chat-group-header-container": 677,
	"./main/containers/chat/chat-group/chat-group-header-container.js": 677,
	"./main/containers/chat/chat-group/chat-group-item-component": 495,
	"./main/containers/chat/chat-group/chat-group-item-component.js": 495,
	"./main/containers/chat/chat-group/chat-group-item-container": 675,
	"./main/containers/chat/chat-group/chat-group-item-container.js": 675,
	"./main/containers/chat/chat-group/chat-group-item-state-component": 676,
	"./main/containers/chat/chat-group/chat-group-item-state-component.js": 676,
	"./main/containers/chat/chat-group/chat-group-list-component": 674,
	"./main/containers/chat/chat-group/chat-group-list-component.js": 674,
	"./main/containers/chat/chat-group/chat-group-list-container": 673,
	"./main/containers/chat/chat-group/chat-group-list-container.js": 673,
	"./main/containers/chat/comment/comment-app-bar-component": 693,
	"./main/containers/chat/comment/comment-app-bar-component.js": 693,
	"./main/containers/chat/comment/comment-app-bar-container": 692,
	"./main/containers/chat/comment/comment-app-bar-container.js": 692,
	"./main/containers/chat/comment/comment-avatar": 269,
	"./main/containers/chat/comment/comment-avatar.js": 269,
	"./main/containers/chat/comment/comment-container": 678,
	"./main/containers/chat/comment/comment-container.js": 678,
	"./main/containers/chat/comment/comment-input-component": 1069,
	"./main/containers/chat/comment/comment-input-component.js": 1069,
	"./main/containers/chat/comment/comment-input-container": 685,
	"./main/containers/chat/comment/comment-input-container.js": 685,
	"./main/containers/chat/comment/comment-input-edit-component": 690,
	"./main/containers/chat/comment/comment-input-edit-component.js": 690,
	"./main/containers/chat/comment/comment-input-edit-container": 689,
	"./main/containers/chat/comment/comment-input-edit-container.js": 689,
	"./main/containers/chat/comment/comment-input-reply-component": 688,
	"./main/containers/chat/comment/comment-input-reply-component.js": 688,
	"./main/containers/chat/comment/comment-input-reply-container": 687,
	"./main/containers/chat/comment/comment-input-reply-container.js": 687,
	"./main/containers/chat/comment/comment-input-suggestion-item": 686,
	"./main/containers/chat/comment/comment-input-suggestion-item.js": 686,
	"./main/containers/chat/comment/comment-item-component": 535,
	"./main/containers/chat/comment/comment-item-component.js": 535,
	"./main/containers/chat/comment/comment-item-container": 681,
	"./main/containers/chat/comment/comment-item-container.js": 681,
	"./main/containers/chat/comment/comment-item-reply-container": 684,
	"./main/containers/chat/comment/comment-item-reply-container.js": 684,
	"./main/containers/chat/comment/comment-list-component": 680,
	"./main/containers/chat/comment/comment-list-component.js": 680,
	"./main/containers/chat/comment/comment-list-container": 679,
	"./main/containers/chat/comment/comment-list-container.js": 679,
	"./main/containers/chat/comment/comment-list-header-container": 691,
	"./main/containers/chat/comment/comment-list-header-container.js": 691,
	"./main/containers/chat/comment/comment-role-label": 357,
	"./main/containers/chat/comment/comment-role-label.js": 357,
	"./main/containers/chat/context": 145,
	"./main/containers/chat/context/": 145,
	"./main/containers/chat/context/index": 145,
	"./main/containers/chat/context/index.js": 145,
	"./main/containers/chat/index": 267,
	"./main/containers/chat/index.js": 267,
	"./main/containers/chat/utils/commentCreatedAt": 356,
	"./main/containers/chat/utils/commentCreatedAt.js": 356,
	"./main/containers/chat/utils/commentToHtml": 355,
	"./main/containers/chat/utils/commentToHtml.js": 355,
	"./main/containers/chat/utils/getRoleLabelText": 683,
	"./main/containers/chat/utils/getRoleLabelText.js": 683,
	"./main/containers/chat/utils/sortMemberList": 694,
	"./main/containers/chat/utils/sortMemberList.js": 694,
	"./main/containers/cost": 630,
	"./main/containers/cost-revenue": 463,
	"./main/containers/cost-revenue/": 463,
	"./main/containers/cost-revenue/Card": 1339,
	"./main/containers/cost-revenue/Card.js": 1339,
	"./main/containers/cost-revenue/CardTable": 142,
	"./main/containers/cost-revenue/CardTable.js": 142,
	"./main/containers/cost-revenue/CostIntro": 945,
	"./main/containers/cost-revenue/CostIntro.js": 945,
	"./main/containers/cost-revenue/CostRevenueCard": 955,
	"./main/containers/cost-revenue/CostRevenueCard.js": 955,
	"./main/containers/cost-revenue/CostRevenueRevenueCard": 950,
	"./main/containers/cost-revenue/CostRevenueRevenueCard.js": 950,
	"./main/containers/cost-revenue/CostsCard": 946,
	"./main/containers/cost-revenue/CostsCard.js": 946,
	"./main/containers/cost-revenue/FixedCost": 947,
	"./main/containers/cost-revenue/FixedCost.js": 947,
	"./main/containers/cost-revenue/Intro": 944,
	"./main/containers/cost-revenue/Intro.js": 944,
	"./main/containers/cost-revenue/Pricing": 952,
	"./main/containers/cost-revenue/Pricing.js": 952,
	"./main/containers/cost-revenue/ProjectedSales": 953,
	"./main/containers/cost-revenue/ProjectedSales.js": 953,
	"./main/containers/cost-revenue/ProjectedSalesCard": 956,
	"./main/containers/cost-revenue/ProjectedSalesCard.js": 956,
	"./main/containers/cost-revenue/ProjectedSalesCardTable": 528,
	"./main/containers/cost-revenue/ProjectedSalesCardTable.js": 528,
	"./main/containers/cost-revenue/RevenueCard": 1340,
	"./main/containers/cost-revenue/RevenueCard.js": 1340,
	"./main/containers/cost-revenue/RevenueIntro": 949,
	"./main/containers/cost-revenue/RevenueIntro.js": 949,
	"./main/containers/cost-revenue/RevenueModel": 951,
	"./main/containers/cost-revenue/RevenueModel.js": 951,
	"./main/containers/cost-revenue/RevenueModelCard": 365,
	"./main/containers/cost-revenue/RevenueModelCard.js": 365,
	"./main/containers/cost-revenue/Summary": 954,
	"./main/containers/cost-revenue/Summary.js": 954,
	"./main/containers/cost-revenue/VariableCost": 948,
	"./main/containers/cost-revenue/VariableCost.js": 948,
	"./main/containers/cost-revenue/cost/FixedCostManualFixedCostInput": 1341,
	"./main/containers/cost-revenue/cost/FixedCostManualFixedCostInput.js": 1341,
	"./main/containers/cost-revenue/index": 463,
	"./main/containers/cost-revenue/index.js": 463,
	"./main/containers/cost/": 630,
	"./main/containers/cost/Card": 532,
	"./main/containers/cost/Card.js": 532,
	"./main/containers/cost/CardTable": 306,
	"./main/containers/cost/CardTable.js": 306,
	"./main/containers/cost/FixedCost": 972,
	"./main/containers/cost/FixedCost.js": 972,
	"./main/containers/cost/Intro": 970,
	"./main/containers/cost/Intro.js": 970,
	"./main/containers/cost/Summary": 973,
	"./main/containers/cost/Summary.js": 973,
	"./main/containers/cost/VariableCost": 971,
	"./main/containers/cost/VariableCost.js": 971,
	"./main/containers/cost/index": 630,
	"./main/containers/cost/index.js": 630,
	"./main/containers/customerSegment": 428,
	"./main/containers/customerSegment/": 428,
	"./main/containers/customerSegment/BuildCustomerPersona": 760,
	"./main/containers/customerSegment/BuildCustomerPersona.js": 760,
	"./main/containers/customerSegment/Card": 274,
	"./main/containers/customerSegment/Card.js": 274,
	"./main/containers/customerSegment/CardBlog": 375,
	"./main/containers/customerSegment/CardBlog.js": 375,
	"./main/containers/customerSegment/CardColourfulArch": 186,
	"./main/containers/customerSegment/CardColourfulArch.js": 186,
	"./main/containers/customerSegment/CardCurrent": 373,
	"./main/containers/customerSegment/CardCurrent.js": 373,
	"./main/containers/customerSegment/CardTech": 376,
	"./main/containers/customerSegment/CardTech.js": 376,
	"./main/containers/customerSegment/DefineYourCustomers": 759,
	"./main/containers/customerSegment/DefineYourCustomers.js": 759,
	"./main/containers/customerSegment/Introduction": 758,
	"./main/containers/customerSegment/Introduction.js": 758,
	"./main/containers/customerSegment/Summary": 761,
	"./main/containers/customerSegment/Summary.js": 761,
	"./main/containers/customerSegment/index": 428,
	"./main/containers/customerSegment/index.js": 428,
	"./main/containers/getKeepGrow": 429,
	"./main/containers/getKeepGrow/": 429,
	"./main/containers/getKeepGrow/GKGTabs": 516,
	"./main/containers/getKeepGrow/GKGTabs.js": 516,
	"./main/containers/getKeepGrow/GKGTabsTemplates": 212,
	"./main/containers/getKeepGrow/GKGTabsTemplates.js": 212,
	"./main/containers/getKeepGrow/Get": 764,
	"./main/containers/getKeepGrow/Get.js": 764,
	"./main/containers/getKeepGrow/Grow": 766,
	"./main/containers/getKeepGrow/Grow.js": 766,
	"./main/containers/getKeepGrow/Intro": 762,
	"./main/containers/getKeepGrow/Intro.js": 762,
	"./main/containers/getKeepGrow/Keep": 765,
	"./main/containers/getKeepGrow/Keep.js": 765,
	"./main/containers/getKeepGrow/Referrals": 767,
	"./main/containers/getKeepGrow/Referrals.js": 767,
	"./main/containers/getKeepGrow/Summary": 768,
	"./main/containers/getKeepGrow/Summary.js": 768,
	"./main/containers/getKeepGrow/index": 429,
	"./main/containers/getKeepGrow/index.js": 429,
	"./main/containers/ideation": 443,
	"./main/containers/ideation/": 443,
	"./main/containers/ideation/Card": 159,
	"./main/containers/ideation/Card.js": 159,
	"./main/containers/ideation/GetInspired": 444,
	"./main/containers/ideation/GetInspired/": 444,
	"./main/containers/ideation/GetInspired/ImageSelector": 918,
	"./main/containers/ideation/GetInspired/ImageSelector.js": 918,
	"./main/containers/ideation/GetInspired/index": 444,
	"./main/containers/ideation/GetInspired/index.js": 444,
	"./main/containers/ideation/IdeationItem": 916,
	"./main/containers/ideation/IdeationItem.js": 916,
	"./main/containers/ideation/Intro": 917,
	"./main/containers/ideation/Intro.js": 917,
	"./main/containers/ideation/PickIdea": 923,
	"./main/containers/ideation/PickIdea.js": 923,
	"./main/containers/ideation/Problems": 919,
	"./main/containers/ideation/Problems.js": 919,
	"./main/containers/ideation/RateYourIdeas": 446,
	"./main/containers/ideation/RateYourIdeas/": 446,
	"./main/containers/ideation/RateYourIdeas/RateIdeaCard": 922,
	"./main/containers/ideation/RateYourIdeas/RateIdeaCard.js": 922,
	"./main/containers/ideation/RateYourIdeas/index": 446,
	"./main/containers/ideation/RateYourIdeas/index.js": 446,
	"./main/containers/ideation/SelectThreeIdeas": 445,
	"./main/containers/ideation/SelectThreeIdeas/": 445,
	"./main/containers/ideation/SelectThreeIdeas/Idea": 602,
	"./main/containers/ideation/SelectThreeIdeas/Idea.js": 602,
	"./main/containers/ideation/SelectThreeIdeas/TheeIdeasSelector": 921,
	"./main/containers/ideation/SelectThreeIdeas/TheeIdeasSelector.js": 921,
	"./main/containers/ideation/SelectThreeIdeas/index": 445,
	"./main/containers/ideation/SelectThreeIdeas/index.js": 445,
	"./main/containers/ideation/Solutions": 920,
	"./main/containers/ideation/Solutions.js": 920,
	"./main/containers/ideation/Summary": 924,
	"./main/containers/ideation/Summary.js": 924,
	"./main/containers/ideation/index": 443,
	"./main/containers/ideation/index.js": 443,
	"./main/containers/keyActivity": 431,
	"./main/containers/keyActivity/": 431,
	"./main/containers/keyActivity/Card": 131,
	"./main/containers/keyActivity/Card.js": 131,
	"./main/containers/keyActivity/Intro": 772,
	"./main/containers/keyActivity/Intro.js": 772,
	"./main/containers/keyActivity/Steps": 773,
	"./main/containers/keyActivity/Steps.js": 773,
	"./main/containers/keyActivity/Summary": 774,
	"./main/containers/keyActivity/Summary.js": 774,
	"./main/containers/keyActivity/index": 431,
	"./main/containers/keyActivity/index.js": 431,
	"./main/containers/keyPartners": 432,
	"./main/containers/keyPartners/": 432,
	"./main/containers/keyPartners/Intro": 775,
	"./main/containers/keyPartners/Intro.js": 775,
	"./main/containers/keyPartners/Summary": 777,
	"./main/containers/keyPartners/Summary.js": 777,
	"./main/containers/keyPartners/YourPartners": 776,
	"./main/containers/keyPartners/YourPartners.js": 776,
	"./main/containers/keyPartners/index": 432,
	"./main/containers/keyPartners/index.js": 432,
	"./main/containers/keyResources": 433,
	"./main/containers/keyResources/": 433,
	"./main/containers/keyResources/Card": 98,
	"./main/containers/keyResources/Card.js": 98,
	"./main/containers/keyResources/Intro": 778,
	"./main/containers/keyResources/Intro.js": 778,
	"./main/containers/keyResources/Resources": 779,
	"./main/containers/keyResources/Resources.js": 779,
	"./main/containers/keyResources/Summary": 780,
	"./main/containers/keyResources/Summary.js": 780,
	"./main/containers/keyResources/index": 433,
	"./main/containers/keyResources/index.js": 433,
	"./main/containers/message/message-item.component": 671,
	"./main/containers/message/message-item.component.js": 671,
	"./main/containers/message/message-item.container": 670,
	"./main/containers/message/message-item.container.js": 670,
	"./main/containers/message/message-list.container": 669,
	"./main/containers/message/message-list.container.js": 669,
	"./main/containers/message/message.container": 1074,
	"./main/containers/message/message.container.js": 1074,
	"./main/containers/portfolio": 435,
	"./main/containers/portfolio/": 435,
	"./main/containers/portfolio/BusinessModalCanvas": 974,
	"./main/containers/portfolio/BusinessModalCanvas.js": 974,
	"./main/containers/portfolio/Channels": 469,
	"./main/containers/portfolio/Channels/": 469,
	"./main/containers/portfolio/Channels/index": 469,
	"./main/containers/portfolio/Channels/index.js": 469,
	"./main/containers/portfolio/ChooseTemplateSection": 323,
	"./main/containers/portfolio/ChooseTemplateSection/": 323,
	"./main/containers/portfolio/ChooseTemplateSection/TemplateColorsList": 786,
	"./main/containers/portfolio/ChooseTemplateSection/TemplateColorsList.js": 786,
	"./main/containers/portfolio/ChooseTemplateSection/TemplateFonts": 787,
	"./main/containers/portfolio/ChooseTemplateSection/TemplateFonts.js": 787,
	"./main/containers/portfolio/ChooseTemplateSection/TemplateList": 785,
	"./main/containers/portfolio/ChooseTemplateSection/TemplateList.js": 785,
	"./main/containers/portfolio/ChooseTemplateSection/index": 323,
	"./main/containers/portfolio/ChooseTemplateSection/index.js": 323,
	"./main/containers/portfolio/CompetitorAnalysis": 470,
	"./main/containers/portfolio/CompetitorAnalysis/": 470,
	"./main/containers/portfolio/CompetitorAnalysis/index": 470,
	"./main/containers/portfolio/CompetitorAnalysis/index.js": 470,
	"./main/containers/portfolio/ContactUs": 471,
	"./main/containers/portfolio/ContactUs/": 471,
	"./main/containers/portfolio/ContactUs/index": 471,
	"./main/containers/portfolio/ContactUs/index.js": 471,
	"./main/containers/portfolio/CustomerRelationships": 472,
	"./main/containers/portfolio/CustomerRelationships/": 472,
	"./main/containers/portfolio/CustomerRelationships/CustomerRelationshipsCard": 975,
	"./main/containers/portfolio/CustomerRelationships/CustomerRelationshipsCard.js": 975,
	"./main/containers/portfolio/CustomerRelationships/CustomerRelationshipsRow": 402,
	"./main/containers/portfolio/CustomerRelationships/CustomerRelationshipsRow.js": 402,
	"./main/containers/portfolio/CustomerRelationships/index": 472,
	"./main/containers/portfolio/CustomerRelationships/index.js": 472,
	"./main/containers/portfolio/CustomerSegment": 976,
	"./main/containers/portfolio/CustomerSegment.js": 976,
	"./main/containers/portfolio/DesirabilitySection": 977,
	"./main/containers/portfolio/DesirabilitySection.js": 977,
	"./main/containers/portfolio/Export": 268,
	"./main/containers/portfolio/Export/": 268,
	"./main/containers/portfolio/Export/Checkbox": 136,
	"./main/containers/portfolio/Export/Checkbox.js": 136,
	"./main/containers/portfolio/Export/Docx": 436,
	"./main/containers/portfolio/Export/Docx/": 436,
	"./main/containers/portfolio/Export/Docx/Constants": 3,
	"./main/containers/portfolio/Export/Docx/Constants/": 3,
	"./main/containers/portfolio/Export/Docx/Constants/ArchitectureOptions": 811,
	"./main/containers/portfolio/Export/Docx/Constants/ArchitectureOptions.js": 811,
	"./main/containers/portfolio/Export/Docx/Constants/BoldOptions": 820,
	"./main/containers/portfolio/Export/Docx/Constants/BoldOptions.js": 820,
	"./main/containers/portfolio/Export/Docx/Constants/ColourfunOptions": 813,
	"./main/containers/portfolio/Export/Docx/Constants/ColourfunOptions.js": 813,
	"./main/containers/portfolio/Export/Docx/Constants/CurrentOptions": 812,
	"./main/containers/portfolio/Export/Docx/Constants/CurrentOptions.js": 812,
	"./main/containers/portfolio/Export/Docx/Constants/FriendlyOptions": 792,
	"./main/containers/portfolio/Export/Docx/Constants/FriendlyOptions.js": 792,
	"./main/containers/portfolio/Export/Docx/Constants/index": 3,
	"./main/containers/portfolio/Export/Docx/Constants/index.js": 3,
	"./main/containers/portfolio/Export/Docx/Pages": 437,
	"./main/containers/portfolio/Export/Docx/Pages/": 437,
	"./main/containers/portfolio/Export/Docx/Pages/blackPage": 547,
	"./main/containers/portfolio/Export/Docx/Pages/blackPage.js": 547,
	"./main/containers/portfolio/Export/Docx/Pages/bmc": 827,
	"./main/containers/portfolio/Export/Docx/Pages/bmc.js": 827,
	"./main/containers/portfolio/Export/Docx/Pages/channels": 841,
	"./main/containers/portfolio/Export/Docx/Pages/channels.js": 841,
	"./main/containers/portfolio/Export/Docx/Pages/competitorAnalysis": 835,
	"./main/containers/portfolio/Export/Docx/Pages/competitorAnalysis.js": 835,
	"./main/containers/portfolio/Export/Docx/Pages/contactUs": 848,
	"./main/containers/portfolio/Export/Docx/Pages/contactUs.js": 848,
	"./main/containers/portfolio/Export/Docx/Pages/customerRelationships": 836,
	"./main/containers/portfolio/Export/Docx/Pages/customerRelationships.js": 836,
	"./main/containers/portfolio/Export/Docx/Pages/customerSegment": 833,
	"./main/containers/portfolio/Export/Docx/Pages/customerSegment.js": 833,
	"./main/containers/portfolio/Export/Docx/Pages/economics": 846,
	"./main/containers/portfolio/Export/Docx/Pages/economics.js": 846,
	"./main/containers/portfolio/Export/Docx/Pages/finance": 837,
	"./main/containers/portfolio/Export/Docx/Pages/finance.js": 837,
	"./main/containers/portfolio/Export/Docx/Pages/forecast": 847,
	"./main/containers/portfolio/Export/Docx/Pages/forecast.js": 847,
	"./main/containers/portfolio/Export/Docx/Pages/graph": 845,
	"./main/containers/portfolio/Export/Docx/Pages/graph.js": 845,
	"./main/containers/portfolio/Export/Docx/Pages/index": 437,
	"./main/containers/portfolio/Export/Docx/Pages/index.js": 437,
	"./main/containers/portfolio/Export/Docx/Pages/key": 840,
	"./main/containers/portfolio/Export/Docx/Pages/key.js": 840,
	"./main/containers/portfolio/Export/Docx/Pages/keyPartners": 842,
	"./main/containers/portfolio/Export/Docx/Pages/keyPartners.js": 842,
	"./main/containers/portfolio/Export/Docx/Pages/main": 791,
	"./main/containers/portfolio/Export/Docx/Pages/main.js": 791,
	"./main/containers/portfolio/Export/Docx/Pages/summary": 823,
	"./main/containers/portfolio/Export/Docx/Pages/summary.js": 823,
	"./main/containers/portfolio/Export/Docx/Pages/sustainabilityList": 838,
	"./main/containers/portfolio/Export/Docx/Pages/sustainabilityList.js": 838,
	"./main/containers/portfolio/Export/Docx/Pages/sustainabilityTable": 839,
	"./main/containers/portfolio/Export/Docx/Pages/sustainabilityTable.js": 839,
	"./main/containers/portfolio/Export/Docx/Pages/teamMate": 826,
	"./main/containers/portfolio/Export/Docx/Pages/teamMate.js": 826,
	"./main/containers/portfolio/Export/Docx/Pages/testing": 828,
	"./main/containers/portfolio/Export/Docx/Pages/testing.js": 828,
	"./main/containers/portfolio/Export/Docx/Pages/valueProposition": 834,
	"./main/containers/portfolio/Export/Docx/Pages/valueProposition.js": 834,
	"./main/containers/portfolio/Export/Docx/assets/7.side_image": 1342,
	"./main/containers/portfolio/Export/Docx/assets/7.side_image.png": 1342,
	"./main/containers/portfolio/Export/Docx/assets/8.side_image": 1343,
	"./main/containers/portfolio/Export/Docx/assets/8.side_image.png": 1343,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg1": 1344,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg1.png": 1344,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg10": 1345,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg10.png": 1345,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg11": 1346,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg11.png": 1346,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg12": 1347,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg12.png": 1347,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg13": 1348,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg13.png": 1348,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg14": 1349,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg14.png": 1349,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg15": 1350,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg15.png": 1350,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg16": 1351,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg16.png": 1351,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg17": 1352,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg17.png": 1352,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg2": 1353,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg2.png": 1353,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg3": 1354,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg3.png": 1354,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg4": 1355,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg4.png": 1355,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg5": 1356,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg5.png": 1356,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg6": 1357,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg6.png": 1357,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg7": 1358,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg7.png": 1358,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg8": 1359,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg8.png": 1359,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg9": 1360,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg9.png": 1360,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg1": 1361,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg1.png": 1361,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg10": 1362,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg10.png": 1362,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg11": 1363,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg11.png": 1363,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg12": 1364,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg12.png": 1364,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg13": 1365,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg13.png": 1365,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg14": 1366,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg14.png": 1366,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg15": 1367,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg15.png": 1367,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg16": 1368,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg16.png": 1368,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg17": 1369,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg17.png": 1369,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg2": 1370,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg2.png": 1370,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg3": 1371,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg3.png": 1371,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg4": 1372,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg4.png": 1372,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg5": 1373,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg5.png": 1373,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg6": 1374,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg6.png": 1374,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg7": 1375,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg7.png": 1375,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg8": 1376,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg8.png": 1376,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg9": 1377,
	"./main/containers/portfolio/Export/Docx/assets/Bold/sdgListIcons/sdg9.png": 1377,
	"./main/containers/portfolio/Export/Docx/assets/arrow-top": 1378,
	"./main/containers/portfolio/Export/Docx/assets/arrow-top.png": 1378,
	"./main/containers/portfolio/Export/Docx/assets/blueRightTopBg": 596,
	"./main/containers/portfolio/Export/Docx/assets/blueRightTopBg.png": 596,
	"./main/containers/portfolio/Export/Docx/assets/bold-download": 821,
	"./main/containers/portfolio/Export/Docx/assets/bold-download.png": 821,
	"./main/containers/portfolio/Export/Docx/assets/colourCustomerTopBg": 594,
	"./main/containers/portfolio/Export/Docx/assets/colourCustomerTopBg.png": 594,
	"./main/containers/portfolio/Export/Docx/assets/colourful_team_circle": 593,
	"./main/containers/portfolio/Export/Docx/assets/colourful_team_circle.svg": 593,
	"./main/containers/portfolio/Export/Docx/assets/colourfunLogoLayer": 822,
	"./main/containers/portfolio/Export/Docx/assets/colourfunLogoLayer.png": 822,
	"./main/containers/portfolio/Export/Docx/assets/data": 1379,
	"./main/containers/portfolio/Export/Docx/assets/data.js": 1379,
	"./main/containers/portfolio/Export/Docx/assets/icons/KP": 844,
	"./main/containers/portfolio/Export/Docx/assets/icons/KP.svg": 844,
	"./main/containers/portfolio/Export/Docx/assets/icons/KR": 843,
	"./main/containers/portfolio/Export/Docx/assets/icons/KR.svg": 843,
	"./main/containers/portfolio/Export/Docx/assets/icons/checked": 829,
	"./main/containers/portfolio/Export/Docx/assets/icons/checked.svg": 829,
	"./main/containers/portfolio/Export/Docx/assets/icons/export": 825,
	"./main/containers/portfolio/Export/Docx/assets/icons/export.png": 825,
	"./main/containers/portfolio/Export/Docx/assets/icons/incomplete": 832,
	"./main/containers/portfolio/Export/Docx/assets/icons/incomplete.svg": 832,
	"./main/containers/portfolio/Export/Docx/assets/icons/invalid": 830,
	"./main/containers/portfolio/Export/Docx/assets/icons/invalid.svg": 830,
	"./main/containers/portfolio/Export/Docx/assets/icons/quote": 824,
	"./main/containers/portfolio/Export/Docx/assets/icons/quote.png": 824,
	"./main/containers/portfolio/Export/Docx/assets/icons/relationship_icon": 597,
	"./main/containers/portfolio/Export/Docx/assets/icons/relationship_icon.svg": 597,
	"./main/containers/portfolio/Export/Docx/assets/icons/unsure": 831,
	"./main/containers/portfolio/Export/Docx/assets/icons/unsure.svg": 831,
	"./main/containers/portfolio/Export/Docx/assets/main": 1380,
	"./main/containers/portfolio/Export/Docx/assets/main.png": 1380,
	"./main/containers/portfolio/Export/Docx/assets/orangeLeftBottomBg": 595,
	"./main/containers/portfolio/Export/Docx/assets/orangeLeftBottomBg.png": 595,
	"./main/containers/portfolio/Export/Docx/assets/person1": 1381,
	"./main/containers/portfolio/Export/Docx/assets/person1.png": 1381,
	"./main/containers/portfolio/Export/Docx/assets/person2": 1382,
	"./main/containers/portfolio/Export/Docx/assets/person2.png": 1382,
	"./main/containers/portfolio/Export/Docx/assets/person3": 1383,
	"./main/containers/portfolio/Export/Docx/assets/person3.png": 1383,
	"./main/containers/portfolio/Export/Docx/assets/sSdgIcon": 1384,
	"./main/containers/portfolio/Export/Docx/assets/sSdgIcon.png": 1384,
	"./main/containers/portfolio/Export/Docx/assets/sdgRectangle": 1385,
	"./main/containers/portfolio/Export/Docx/assets/sdgRectangle.png": 1385,
	"./main/containers/portfolio/Export/Docx/assets/small-docx-no-image": 1386,
	"./main/containers/portfolio/Export/Docx/assets/small-docx-no-image.png": 1386,
	"./main/containers/portfolio/Export/Docx/assets/step1": 1387,
	"./main/containers/portfolio/Export/Docx/assets/step1.png": 1387,
	"./main/containers/portfolio/Export/Docx/assets/step2": 1388,
	"./main/containers/portfolio/Export/Docx/assets/step2.png": 1388,
	"./main/containers/portfolio/Export/Docx/assets/sumLeftRight": 815,
	"./main/containers/portfolio/Export/Docx/assets/sumLeftRight.png": 815,
	"./main/containers/portfolio/Export/Docx/assets/sumRightBg": 816,
	"./main/containers/portfolio/Export/Docx/assets/sumRightBg.png": 816,
	"./main/containers/portfolio/Export/Docx/assets/teamRigthBg": 819,
	"./main/containers/portfolio/Export/Docx/assets/teamRigthBg.png": 819,
	"./main/containers/portfolio/Export/Docx/assets/testingLeftBottomBg": 817,
	"./main/containers/portfolio/Export/Docx/assets/testingLeftBottomBg.png": 817,
	"./main/containers/portfolio/Export/Docx/assets/testingRightTopBg": 818,
	"./main/containers/portfolio/Export/Docx/assets/testingRightTopBg.png": 818,
	"./main/containers/portfolio/Export/Docx/assets/valuePropBottomBg": 814,
	"./main/containers/portfolio/Export/Docx/assets/valuePropBottomBg.png": 814,
	"./main/containers/portfolio/Export/Docx/helpers": 11,
	"./main/containers/portfolio/Export/Docx/helpers/": 11,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/assets/circle280": 592,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/assets/circle280.png": 592,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/assets/circle340": 793,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/assets/circle340.png": 793,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/assets/half": 591,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/assets/half.png": 591,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/utils": 44,
	"./main/containers/portfolio/Export/Docx/helpers/ImageService/utils.js": 44,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons": 395,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/": 395,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg1": 794,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg1.svg": 794,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg10": 803,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg10.svg": 803,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg11": 804,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg11.svg": 804,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg12": 805,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg12.svg": 805,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg13": 806,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg13.svg": 806,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg14": 807,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg14.svg": 807,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg15": 808,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg15.svg": 808,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg16": 809,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg16.svg": 809,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg17": 810,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg17.svg": 810,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg2": 795,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg2.svg": 795,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg3": 796,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg3.svg": 796,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg4": 797,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg4.svg": 797,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg5": 798,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg5.svg": 798,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg6": 799,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg6.svg": 799,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg7": 800,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg7.svg": 800,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg8": 801,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg8.svg": 801,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg9": 802,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg9.svg": 802,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/index": 395,
	"./main/containers/portfolio/Export/Docx/helpers/SdgIcons/index.js": 395,
	"./main/containers/portfolio/Export/Docx/helpers/index": 11,
	"./main/containers/portfolio/Export/Docx/helpers/index.js": 11,
	"./main/containers/portfolio/Export/Docx/index": 436,
	"./main/containers/portfolio/Export/Docx/index.js": 436,
	"./main/containers/portfolio/Export/Footer": 788,
	"./main/containers/portfolio/Export/Footer.js": 788,
	"./main/containers/portfolio/Export/PDF": 789,
	"./main/containers/portfolio/Export/PDF.js": 789,
	"./main/containers/portfolio/Export/PPT": 1389,
	"./main/containers/portfolio/Export/PPT.js": 1389,
	"./main/containers/portfolio/Export/WebLink": 790,
	"./main/containers/portfolio/Export/WebLink.js": 790,
	"./main/containers/portfolio/Export/index": 268,
	"./main/containers/portfolio/Export/index.js": 268,
	"./main/containers/portfolio/Feasibility": 978,
	"./main/containers/portfolio/Feasibility.js": 978,
	"./main/containers/portfolio/Finance": 473,
	"./main/containers/portfolio/Finance/": 473,
	"./main/containers/portfolio/Finance/Chart": 305,
	"./main/containers/portfolio/Finance/Chart.js": 305,
	"./main/containers/portfolio/Finance/Forecast": 132,
	"./main/containers/portfolio/Finance/Forecast.js": 132,
	"./main/containers/portfolio/Finance/SubChapter": 311,
	"./main/containers/portfolio/Finance/SubChapter.js": 311,
	"./main/containers/portfolio/Finance/UnitEconomics": 523,
	"./main/containers/portfolio/Finance/UnitEconomics.js": 523,
	"./main/containers/portfolio/Finance/index": 473,
	"./main/containers/portfolio/Finance/index.js": 473,
	"./main/containers/portfolio/Introduction": 979,
	"./main/containers/portfolio/Introduction.js": 979,
	"./main/containers/portfolio/KeyActivities": 980,
	"./main/containers/portfolio/KeyActivities.js": 980,
	"./main/containers/portfolio/PortfolioSectionAdmin": 961,
	"./main/containers/portfolio/PortfolioSectionAdmin.js": 961,
	"./main/containers/portfolio/PortfolioSections": 1390,
	"./main/containers/portfolio/PortfolioSections.js": 1390,
	"./main/containers/portfolio/ProjectSummary": 474,
	"./main/containers/portfolio/ProjectSummary/": 474,
	"./main/containers/portfolio/ProjectSummary/UploadFiles": 981,
	"./main/containers/portfolio/ProjectSummary/UploadFiles.js": 981,
	"./main/containers/portfolio/ProjectSummary/index": 474,
	"./main/containers/portfolio/ProjectSummary/index.js": 474,
	"./main/containers/portfolio/SectionHeader": 76,
	"./main/containers/portfolio/SectionHeader.js": 76,
	"./main/containers/portfolio/Sustainability": 477,
	"./main/containers/portfolio/Sustainability/": 477,
	"./main/containers/portfolio/Sustainability/index": 477,
	"./main/containers/portfolio/Sustainability/index.js": 477,
	"./main/containers/portfolio/Team": 475,
	"./main/containers/portfolio/Team/": 475,
	"./main/containers/portfolio/Team/TeamCard": 982,
	"./main/containers/portfolio/Team/TeamCard.js": 982,
	"./main/containers/portfolio/Team/index": 475,
	"./main/containers/portfolio/Team/index.js": 475,
	"./main/containers/portfolio/Testing": 476,
	"./main/containers/portfolio/Testing/": 476,
	"./main/containers/portfolio/Testing/index": 476,
	"./main/containers/portfolio/Testing/index.js": 476,
	"./main/containers/portfolio/ValueProposition": 983,
	"./main/containers/portfolio/ValueProposition.js": 983,
	"./main/containers/portfolio/Viability": 984,
	"./main/containers/portfolio/Viability.js": 984,
	"./main/containers/portfolio/architecturalMinimal": 327,
	"./main/containers/portfolio/architecturalMinimal/": 327,
	"./main/containers/portfolio/architecturalMinimal/ChannelsArch": 889,
	"./main/containers/portfolio/architecturalMinimal/ChannelsArch.js": 889,
	"./main/containers/portfolio/architecturalMinimal/ContactUsArch": 890,
	"./main/containers/portfolio/architecturalMinimal/ContactUsArch.js": 890,
	"./main/containers/portfolio/architecturalMinimal/CustomerSegmentArch": 887,
	"./main/containers/portfolio/architecturalMinimal/CustomerSegmentArch.js": 887,
	"./main/containers/portfolio/architecturalMinimal/IntroductionArch": 857,
	"./main/containers/portfolio/architecturalMinimal/IntroductionArch.js": 857,
	"./main/containers/portfolio/architecturalMinimal/SummaryArch": 862,
	"./main/containers/portfolio/architecturalMinimal/SummaryArch.js": 862,
	"./main/containers/portfolio/architecturalMinimal/Team/TeamArch": 870,
	"./main/containers/portfolio/architecturalMinimal/Team/TeamArch.js": 870,
	"./main/containers/portfolio/architecturalMinimal/Team/TeamCard": 871,
	"./main/containers/portfolio/architecturalMinimal/Team/TeamCard.js": 871,
	"./main/containers/portfolio/architecturalMinimal/ValuePropositionArch": 888,
	"./main/containers/portfolio/architecturalMinimal/ValuePropositionArch.js": 888,
	"./main/containers/portfolio/architecturalMinimal/index": 327,
	"./main/containers/portfolio/architecturalMinimal/index.js": 327,
	"./main/containers/portfolio/blogFriendly": 326,
	"./main/containers/portfolio/blogFriendly/": 326,
	"./main/containers/portfolio/blogFriendly/ChannelsBlog": 885,
	"./main/containers/portfolio/blogFriendly/ChannelsBlog.js": 885,
	"./main/containers/portfolio/blogFriendly/ContactUsBlog": 886,
	"./main/containers/portfolio/blogFriendly/ContactUsBlog.js": 886,
	"./main/containers/portfolio/blogFriendly/CustomerSegmentBlog": 883,
	"./main/containers/portfolio/blogFriendly/CustomerSegmentBlog.js": 883,
	"./main/containers/portfolio/blogFriendly/IntroductionBlog": 856,
	"./main/containers/portfolio/blogFriendly/IntroductionBlog.js": 856,
	"./main/containers/portfolio/blogFriendly/SummaryBlog": 861,
	"./main/containers/portfolio/blogFriendly/SummaryBlog.js": 861,
	"./main/containers/portfolio/blogFriendly/Team/TeamBlog": 868,
	"./main/containers/portfolio/blogFriendly/Team/TeamBlog.js": 868,
	"./main/containers/portfolio/blogFriendly/Team/TeamCard": 869,
	"./main/containers/portfolio/blogFriendly/Team/TeamCard.js": 869,
	"./main/containers/portfolio/blogFriendly/ValuePropositionBlog": 884,
	"./main/containers/portfolio/blogFriendly/ValuePropositionBlog.js": 884,
	"./main/containers/portfolio/blogFriendly/index": 326,
	"./main/containers/portfolio/blogFriendly/index.js": 326,
	"./main/containers/portfolio/boldTemplate": 328,
	"./main/containers/portfolio/boldTemplate/": 328,
	"./main/containers/portfolio/boldTemplate/ChannelsBold": 910,
	"./main/containers/portfolio/boldTemplate/ChannelsBold.js": 910,
	"./main/containers/portfolio/boldTemplate/ContactUsBold": 911,
	"./main/containers/portfolio/boldTemplate/ContactUsBold.js": 911,
	"./main/containers/portfolio/boldTemplate/CustomerSegmentBold": 908,
	"./main/containers/portfolio/boldTemplate/CustomerSegmentBold.js": 908,
	"./main/containers/portfolio/boldTemplate/IntroductionBold": 858,
	"./main/containers/portfolio/boldTemplate/IntroductionBold.js": 858,
	"./main/containers/portfolio/boldTemplate/SummaryBold": 863,
	"./main/containers/portfolio/boldTemplate/SummaryBold.js": 863,
	"./main/containers/portfolio/boldTemplate/TeamBold": 439,
	"./main/containers/portfolio/boldTemplate/TeamBold/": 439,
	"./main/containers/portfolio/boldTemplate/TeamBold/TeamCard": 867,
	"./main/containers/portfolio/boldTemplate/TeamBold/TeamCard.js": 867,
	"./main/containers/portfolio/boldTemplate/TeamBold/index": 439,
	"./main/containers/portfolio/boldTemplate/TeamBold/index.js": 439,
	"./main/containers/portfolio/boldTemplate/ValuePropositionBold": 909,
	"./main/containers/portfolio/boldTemplate/ValuePropositionBold.js": 909,
	"./main/containers/portfolio/boldTemplate/index": 328,
	"./main/containers/portfolio/boldTemplate/index.js": 328,
	"./main/containers/portfolio/colourfulFunTemplate": 325,
	"./main/containers/portfolio/colourfulFunTemplate/": 325,
	"./main/containers/portfolio/colourfulFunTemplate/ChannelsColourful": 881,
	"./main/containers/portfolio/colourfulFunTemplate/ChannelsColourful.js": 881,
	"./main/containers/portfolio/colourfulFunTemplate/ContactUsColourful": 882,
	"./main/containers/portfolio/colourfulFunTemplate/ContactUsColourful.js": 882,
	"./main/containers/portfolio/colourfulFunTemplate/CustomerSegmentColourful": 879,
	"./main/containers/portfolio/colourfulFunTemplate/CustomerSegmentColourful.js": 879,
	"./main/containers/portfolio/colourfulFunTemplate/IntroductionColourfulFun": 855,
	"./main/containers/portfolio/colourfulFunTemplate/IntroductionColourfulFun.js": 855,
	"./main/containers/portfolio/colourfulFunTemplate/SummaryColourfulFun": 860,
	"./main/containers/portfolio/colourfulFunTemplate/SummaryColourfulFun.js": 860,
	"./main/containers/portfolio/colourfulFunTemplate/Team/TeamCard": 866,
	"./main/containers/portfolio/colourfulFunTemplate/Team/TeamCard.js": 866,
	"./main/containers/portfolio/colourfulFunTemplate/Team/TeamColourfulFun": 865,
	"./main/containers/portfolio/colourfulFunTemplate/Team/TeamColourfulFun.js": 865,
	"./main/containers/portfolio/colourfulFunTemplate/ValuePropositionColourful": 880,
	"./main/containers/portfolio/colourfulFunTemplate/ValuePropositionColourful.js": 880,
	"./main/containers/portfolio/colourfulFunTemplate/index": 325,
	"./main/containers/portfolio/colourfulFunTemplate/index.js": 325,
	"./main/containers/portfolio/currentTemplate": 324,
	"./main/containers/portfolio/currentTemplate/": 324,
	"./main/containers/portfolio/currentTemplate/ChannelsCurent": 852,
	"./main/containers/portfolio/currentTemplate/ChannelsCurent.js": 852,
	"./main/containers/portfolio/currentTemplate/ContactUsCurrent": 853,
	"./main/containers/portfolio/currentTemplate/ContactUsCurrent.js": 853,
	"./main/containers/portfolio/currentTemplate/CustomerSegmentCurrent": 849,
	"./main/containers/portfolio/currentTemplate/CustomerSegmentCurrent.js": 849,
	"./main/containers/portfolio/currentTemplate/IntroductionCurrent": 854,
	"./main/containers/portfolio/currentTemplate/IntroductionCurrent.js": 854,
	"./main/containers/portfolio/currentTemplate/SummaryCurrent": 859,
	"./main/containers/portfolio/currentTemplate/SummaryCurrent.js": 859,
	"./main/containers/portfolio/currentTemplate/TeamCurrent": 438,
	"./main/containers/portfolio/currentTemplate/TeamCurrent/": 438,
	"./main/containers/portfolio/currentTemplate/TeamCurrent/TeamCard": 864,
	"./main/containers/portfolio/currentTemplate/TeamCurrent/TeamCard.js": 864,
	"./main/containers/portfolio/currentTemplate/TeamCurrent/index": 438,
	"./main/containers/portfolio/currentTemplate/TeamCurrent/index.js": 438,
	"./main/containers/portfolio/currentTemplate/ValuePropositionCurrent": 850,
	"./main/containers/portfolio/currentTemplate/ValuePropositionCurrent.js": 850,
	"./main/containers/portfolio/currentTemplate/index": 324,
	"./main/containers/portfolio/currentTemplate/index.js": 324,
	"./main/containers/portfolio/index": 435,
	"./main/containers/portfolio/index.js": 435,
	"./main/containers/portfolio/mainTemplateComponents/BMC": 219,
	"./main/containers/portfolio/mainTemplateComponents/BMC.js": 219,
	"./main/containers/portfolio/mainTemplateComponents/CompetitorAnalysis": 225,
	"./main/containers/portfolio/mainTemplateComponents/CompetitorAnalysis.js": 225,
	"./main/containers/portfolio/mainTemplateComponents/CustomerRelationships": 226,
	"./main/containers/portfolio/mainTemplateComponents/CustomerRelationships.js": 226,
	"./main/containers/portfolio/mainTemplateComponents/Desirability": 222,
	"./main/containers/portfolio/mainTemplateComponents/Desirability.js": 222,
	"./main/containers/portfolio/mainTemplateComponents/Feasibility": 224,
	"./main/containers/portfolio/mainTemplateComponents/Feasibility.js": 224,
	"./main/containers/portfolio/mainTemplateComponents/Finance": 228,
	"./main/containers/portfolio/mainTemplateComponents/Finance.js": 228,
	"./main/containers/portfolio/mainTemplateComponents/Introduction": 216,
	"./main/containers/portfolio/mainTemplateComponents/Introduction.js": 216,
	"./main/containers/portfolio/mainTemplateComponents/KeyActivities": 227,
	"./main/containers/portfolio/mainTemplateComponents/KeyActivities.js": 227,
	"./main/containers/portfolio/mainTemplateComponents/Summary": 217,
	"./main/containers/portfolio/mainTemplateComponents/Summary.js": 217,
	"./main/containers/portfolio/mainTemplateComponents/Sustainability": 229,
	"./main/containers/portfolio/mainTemplateComponents/Sustainability.js": 229,
	"./main/containers/portfolio/mainTemplateComponents/Team": 218,
	"./main/containers/portfolio/mainTemplateComponents/Team.js": 218,
	"./main/containers/portfolio/mainTemplateComponents/Testing": 220,
	"./main/containers/portfolio/mainTemplateComponents/Testing.js": 220,
	"./main/containers/portfolio/mainTemplateComponents/Viability": 223,
	"./main/containers/portfolio/mainTemplateComponents/Viability.js": 223,
	"./main/containers/portfolio/techModernTemplate": 440,
	"./main/containers/portfolio/techModernTemplate/": 440,
	"./main/containers/portfolio/techModernTemplate/BusinessModelCanvasTech": 894,
	"./main/containers/portfolio/techModernTemplate/BusinessModelCanvasTech.js": 894,
	"./main/containers/portfolio/techModernTemplate/ChannelsTech": 901,
	"./main/containers/portfolio/techModernTemplate/ChannelsTech.js": 901,
	"./main/containers/portfolio/techModernTemplate/CompetitorAnalysisTech": 899,
	"./main/containers/portfolio/techModernTemplate/CompetitorAnalysisTech.js": 899,
	"./main/containers/portfolio/techModernTemplate/ContactUsTech": 907,
	"./main/containers/portfolio/techModernTemplate/ContactUsTech.js": 907,
	"./main/containers/portfolio/techModernTemplate/CustomerRelationshipsTech": 900,
	"./main/containers/portfolio/techModernTemplate/CustomerRelationshipsTech.js": 900,
	"./main/containers/portfolio/techModernTemplate/CustomerSegmentTech": 897,
	"./main/containers/portfolio/techModernTemplate/CustomerSegmentTech.js": 897,
	"./main/containers/portfolio/techModernTemplate/DesirabilityTech": 896,
	"./main/containers/portfolio/techModernTemplate/DesirabilityTech.js": 896,
	"./main/containers/portfolio/techModernTemplate/FeasibilityTech": 902,
	"./main/containers/portfolio/techModernTemplate/FeasibilityTech.js": 902,
	"./main/containers/portfolio/techModernTemplate/FinanceTech": 905,
	"./main/containers/portfolio/techModernTemplate/FinanceTech.js": 905,
	"./main/containers/portfolio/techModernTemplate/IntroductionTech": 891,
	"./main/containers/portfolio/techModernTemplate/IntroductionTech.js": 891,
	"./main/containers/portfolio/techModernTemplate/KeyActivitiesTech": 903,
	"./main/containers/portfolio/techModernTemplate/KeyActivitiesTech.js": 903,
	"./main/containers/portfolio/techModernTemplate/SummaryTech": 892,
	"./main/containers/portfolio/techModernTemplate/SummaryTech.js": 892,
	"./main/containers/portfolio/techModernTemplate/SustainabilityTech": 906,
	"./main/containers/portfolio/techModernTemplate/SustainabilityTech.js": 906,
	"./main/containers/portfolio/techModernTemplate/Team": 441,
	"./main/containers/portfolio/techModernTemplate/Team/": 441,
	"./main/containers/portfolio/techModernTemplate/Team/TeamCard": 893,
	"./main/containers/portfolio/techModernTemplate/Team/TeamCard.js": 893,
	"./main/containers/portfolio/techModernTemplate/Team/index": 441,
	"./main/containers/portfolio/techModernTemplate/Team/index.js": 441,
	"./main/containers/portfolio/techModernTemplate/TestingTech": 895,
	"./main/containers/portfolio/techModernTemplate/TestingTech.js": 895,
	"./main/containers/portfolio/techModernTemplate/ValuePropositionTech": 898,
	"./main/containers/portfolio/techModernTemplate/ValuePropositionTech.js": 898,
	"./main/containers/portfolio/techModernTemplate/ViabilityTech": 904,
	"./main/containers/portfolio/techModernTemplate/ViabilityTech.js": 904,
	"./main/containers/portfolio/techModernTemplate/index": 440,
	"./main/containers/portfolio/techModernTemplate/index.js": 440,
	"./main/containers/revenue": 631,
	"./main/containers/revenue/": 631,
	"./main/containers/revenue/Card": 533,
	"./main/containers/revenue/Card.js": 533,
	"./main/containers/revenue/Intro": 985,
	"./main/containers/revenue/Intro.js": 985,
	"./main/containers/revenue/Pricing": 987,
	"./main/containers/revenue/Pricing.js": 987,
	"./main/containers/revenue/ProjectedSales": 988,
	"./main/containers/revenue/ProjectedSales.js": 988,
	"./main/containers/revenue/RevenueModel": 986,
	"./main/containers/revenue/RevenueModel.js": 986,
	"./main/containers/revenue/RevenueModelCard": 529,
	"./main/containers/revenue/RevenueModelCard.js": 529,
	"./main/containers/revenue/Summary": 989,
	"./main/containers/revenue/Summary.js": 989,
	"./main/containers/revenue/index": 631,
	"./main/containers/revenue/index.js": 631,
	"./main/containers/sustainability": 434,
	"./main/containers/sustainability/": 434,
	"./main/containers/sustainability/Card": 147,
	"./main/containers/sustainability/Card.js": 147,
	"./main/containers/sustainability/Goals": 783,
	"./main/containers/sustainability/Goals.js": 783,
	"./main/containers/sustainability/Intro": 781,
	"./main/containers/sustainability/Intro.js": 781,
	"./main/containers/sustainability/Slider": 1391,
	"./main/containers/sustainability/Slider.js": 1391,
	"./main/containers/sustainability/Strategy": 1071,
	"./main/containers/sustainability/Strategy.js": 1071,
	"./main/containers/sustainability/Summary": 784,
	"./main/containers/sustainability/Summary.js": 784,
	"./main/containers/sustainability/Table": 782,
	"./main/containers/sustainability/Table.js": 782,
	"./main/containers/sustainability/components/GoalSplitRows": 517,
	"./main/containers/sustainability/components/GoalSplitRows.js": 517,
	"./main/containers/sustainability/index": 434,
	"./main/containers/sustainability/index.js": 434,
	"./main/containers/testing": 447,
	"./main/containers/testing/": 447,
	"./main/containers/testing/Components/CheckBox": 127,
	"./main/containers/testing/Components/CheckBox.js": 127,
	"./main/containers/testing/Components/ExampleCard": 927,
	"./main/containers/testing/Components/ExampleCard.js": 927,
	"./main/containers/testing/Components/Footer": 527,
	"./main/containers/testing/Components/Footer.js": 527,
	"./main/containers/testing/Components/Modal": 156,
	"./main/containers/testing/Components/Modal.js": 156,
	"./main/containers/testing/Components/ResourceUploader": 189,
	"./main/containers/testing/Components/ResourceUploader.js": 189,
	"./main/containers/testing/Components/ResponseCard": 520,
	"./main/containers/testing/Components/ResponseCard.js": 520,
	"./main/containers/testing/Components/Select/IconBlock": 521,
	"./main/containers/testing/Components/Select/IconBlock.js": 521,
	"./main/containers/testing/Components/Select/SelectV2": 872,
	"./main/containers/testing/Components/Select/SelectV2.js": 872,
	"./main/containers/testing/Components/Select/SelectV3": 876,
	"./main/containers/testing/Components/Select/SelectV3.js": 876,
	"./main/containers/testing/Components/SpecialList": 929,
	"./main/containers/testing/Components/SpecialList.js": 929,
	"./main/containers/testing/Components/TectCardBlocks/AnalyseTestResultsBlock": 1392,
	"./main/containers/testing/Components/TectCardBlocks/AnalyseTestResultsBlock.js": 1392,
	"./main/containers/testing/Components/TectCardBlocks/AssumptionBlock": 877,
	"./main/containers/testing/Components/TectCardBlocks/AssumptionBlock.js": 877,
	"./main/containers/testing/Components/TectCardBlocks/TestPlanBlock": 599,
	"./main/containers/testing/Components/TectCardBlocks/TestPlanBlock.js": 599,
	"./main/containers/testing/Components/TectCardBlocks/TestResultsBlock": 600,
	"./main/containers/testing/Components/TectCardBlocks/TestResultsBlock.js": 600,
	"./main/containers/testing/Components/TectCardBlocks/TestStatusBlock": 873,
	"./main/containers/testing/Components/TectCardBlocks/TestStatusBlock.js": 873,
	"./main/containers/testing/Components/TectCardBlocks/UploadsBlock": 522,
	"./main/containers/testing/Components/TectCardBlocks/UploadsBlock.js": 522,
	"./main/containers/testing/Components/TestCard": 221,
	"./main/containers/testing/Components/TestCard.js": 221,
	"./main/containers/testing/Components/TestRow": 157,
	"./main/containers/testing/Components/TestRow.js": 157,
	"./main/containers/testing/Components/TestStatus": 304,
	"./main/containers/testing/Components/TestStatus.js": 304,
	"./main/containers/testing/Components/TestStatusSelector": 874,
	"./main/containers/testing/Components/TestStatusSelector.js": 874,
	"./main/containers/testing/Components/TestTypeCard": 931,
	"./main/containers/testing/Components/TestTypeCard.js": 931,
	"./main/containers/testing/Components/WebsiteCard": 188,
	"./main/containers/testing/Components/WebsiteCard.js": 188,
	"./main/containers/testing/Containers/Select/SelectBmcBlockTested": 875,
	"./main/containers/testing/Containers/Select/SelectBmcBlockTested.js": 875,
	"./main/containers/testing/Containers/TestItem": 448,
	"./main/containers/testing/Containers/TestItem/": 448,
	"./main/containers/testing/Containers/TestItem/AnalyseResults": 459,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/": 459,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/GeneralPage": 940,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/GeneralPage.js": 940,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/Homepage": 460,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/Homepage/": 460,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/Homepage/index": 460,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/Homepage/index.js": 460,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/index": 459,
	"./main/containers/testing/Containers/TestItem/AnalyseResults/index.js": 459,
	"./main/containers/testing/Containers/TestItem/BuildTest": 449,
	"./main/containers/testing/Containers/TestItem/BuildTest/": 449,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage": 450,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/": 450,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/index": 450,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/index.js": 450,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/First": 932,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/First.js": 932,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/Fourth": 935,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/Fourth.js": 935,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/Second": 933,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/Second.js": 933,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/Third": 934,
	"./main/containers/testing/Containers/TestItem/BuildTest/Homepage/templates/Third.js": 934,
	"./main/containers/testing/Containers/TestItem/BuildTest/Intreview": 453,
	"./main/containers/testing/Containers/TestItem/BuildTest/Intreview/": 453,
	"./main/containers/testing/Containers/TestItem/BuildTest/Intreview/index": 453,
	"./main/containers/testing/Containers/TestItem/BuildTest/Intreview/index.js": 453,
	"./main/containers/testing/Containers/TestItem/BuildTest/Prototype": 454,
	"./main/containers/testing/Containers/TestItem/BuildTest/Prototype/": 454,
	"./main/containers/testing/Containers/TestItem/BuildTest/Prototype/index": 454,
	"./main/containers/testing/Containers/TestItem/BuildTest/Prototype/index.js": 454,
	"./main/containers/testing/Containers/TestItem/BuildTest/Research": 451,
	"./main/containers/testing/Containers/TestItem/BuildTest/Research/": 451,
	"./main/containers/testing/Containers/TestItem/BuildTest/Research/index": 451,
	"./main/containers/testing/Containers/TestItem/BuildTest/Research/index.js": 451,
	"./main/containers/testing/Containers/TestItem/BuildTest/Sell": 455,
	"./main/containers/testing/Containers/TestItem/BuildTest/Sell/": 455,
	"./main/containers/testing/Containers/TestItem/BuildTest/Sell/index": 455,
	"./main/containers/testing/Containers/TestItem/BuildTest/Sell/index.js": 455,
	"./main/containers/testing/Containers/TestItem/BuildTest/Survey": 452,
	"./main/containers/testing/Containers/TestItem/BuildTest/Survey/": 452,
	"./main/containers/testing/Containers/TestItem/BuildTest/Survey/index": 452,
	"./main/containers/testing/Containers/TestItem/BuildTest/Survey/index.js": 452,
	"./main/containers/testing/Containers/TestItem/BuildTest/index": 449,
	"./main/containers/testing/Containers/TestItem/BuildTest/index.js": 449,
	"./main/containers/testing/Containers/TestItem/ChooseTest": 930,
	"./main/containers/testing/Containers/TestItem/ChooseTest.js": 930,
	"./main/containers/testing/Containers/TestItem/CriticalAssumption": 928,
	"./main/containers/testing/Containers/TestItem/CriticalAssumption.js": 928,
	"./main/containers/testing/Containers/TestItem/Intro": 925,
	"./main/containers/testing/Containers/TestItem/Intro.js": 925,
	"./main/containers/testing/Containers/TestItem/Summary": 461,
	"./main/containers/testing/Containers/TestItem/Summary/": 461,
	"./main/containers/testing/Containers/TestItem/Summary/GeneralPage": 941,
	"./main/containers/testing/Containers/TestItem/Summary/GeneralPage.js": 941,
	"./main/containers/testing/Containers/TestItem/Summary/Homepage": 462,
	"./main/containers/testing/Containers/TestItem/Summary/Homepage/": 462,
	"./main/containers/testing/Containers/TestItem/Summary/Homepage/index": 462,
	"./main/containers/testing/Containers/TestItem/Summary/Homepage/index.js": 462,
	"./main/containers/testing/Containers/TestItem/Summary/index": 461,
	"./main/containers/testing/Containers/TestItem/Summary/index.js": 461,
	"./main/containers/testing/Containers/TestItem/TestPlan": 456,
	"./main/containers/testing/Containers/TestItem/TestPlan/": 456,
	"./main/containers/testing/Containers/TestItem/TestPlan/Homepage": 457,
	"./main/containers/testing/Containers/TestItem/TestPlan/Homepage/": 457,
	"./main/containers/testing/Containers/TestItem/TestPlan/Homepage/index": 457,
	"./main/containers/testing/Containers/TestItem/TestPlan/Homepage/index.js": 457,
	"./main/containers/testing/Containers/TestItem/TestPlan/Interview": 937,
	"./main/containers/testing/Containers/TestItem/TestPlan/Interview.js": 937,
	"./main/containers/testing/Containers/TestItem/TestPlan/Page": 180,
	"./main/containers/testing/Containers/TestItem/TestPlan/Page/": 180,
	"./main/containers/testing/Containers/TestItem/TestPlan/Page/index": 180,
	"./main/containers/testing/Containers/TestItem/TestPlan/Page/index.js": 180,
	"./main/containers/testing/Containers/TestItem/TestPlan/Prototype": 938,
	"./main/containers/testing/Containers/TestItem/TestPlan/Prototype.js": 938,
	"./main/containers/testing/Containers/TestItem/TestPlan/Research": 458,
	"./main/containers/testing/Containers/TestItem/TestPlan/Research/": 458,
	"./main/containers/testing/Containers/TestItem/TestPlan/Research/index": 458,
	"./main/containers/testing/Containers/TestItem/TestPlan/Research/index.js": 458,
	"./main/containers/testing/Containers/TestItem/TestPlan/Sell": 939,
	"./main/containers/testing/Containers/TestItem/TestPlan/Sell.js": 939,
	"./main/containers/testing/Containers/TestItem/TestPlan/Survey": 936,
	"./main/containers/testing/Containers/TestItem/TestPlan/Survey.js": 936,
	"./main/containers/testing/Containers/TestItem/TestPlan/index": 456,
	"./main/containers/testing/Containers/TestItem/TestPlan/index.js": 456,
	"./main/containers/testing/Containers/TestItem/index": 448,
	"./main/containers/testing/Containers/TestItem/index.js": 448,
	"./main/containers/testing/Containers/TestList": 465,
	"./main/containers/testing/Containers/TestList/": 465,
	"./main/containers/testing/Containers/TestList/index": 465,
	"./main/containers/testing/Containers/TestList/index.js": 465,
	"./main/containers/testing/index": 447,
	"./main/containers/testing/index.js": 447,
	"./main/containers/tips/FirstTimeTip": 183,
	"./main/containers/tips/FirstTimeTip.js": 183,
	"./main/containers/tips/TipCustomerSegment": 742,
	"./main/containers/tips/TipCustomerSegment.js": 742,
	"./main/containers/valueProposition": 426,
	"./main/containers/valueProposition/": 426,
	"./main/containers/valueProposition/Card": 213,
	"./main/containers/valueProposition/Card.js": 213,
	"./main/containers/valueProposition/CardBlog": 524,
	"./main/containers/valueProposition/CardBlog.js": 524,
	"./main/containers/valueProposition/CardCurrent": 851,
	"./main/containers/valueProposition/CardCurrent.js": 851,
	"./main/containers/valueProposition/Competitors": 746,
	"./main/containers/valueProposition/Competitors.js": 746,
	"./main/containers/valueProposition/CompetitorsCard": 276,
	"./main/containers/valueProposition/CompetitorsCard.js": 276,
	"./main/containers/valueProposition/CompetitorsCardTemplates": 280,
	"./main/containers/valueProposition/CompetitorsCardTemplates.js": 280,
	"./main/containers/valueProposition/Introduction": 741,
	"./main/containers/valueProposition/Introduction.js": 741,
	"./main/containers/valueProposition/ProductAndFeatures": 744,
	"./main/containers/valueProposition/ProductAndFeatures.js": 744,
	"./main/containers/valueProposition/Summary": 748,
	"./main/containers/valueProposition/Summary.js": 748,
	"./main/containers/valueProposition/UniqueValueProposition": 747,
	"./main/containers/valueProposition/UniqueValueProposition.js": 747,
	"./main/containers/valueProposition/index": 426,
	"./main/containers/valueProposition/index.js": 426,
	"./main/hooks/preload": 739,
	"./main/hooks/preload.js": 739,
	"./main/index": 629,
	"./main/index.js": 629,
	"./main/models/alert": 181,
	"./main/models/alert.js": 181,
	"./main/models/bmc": 331,
	"./main/models/bmc.js": 331,
	"./main/models/bmcProgress": 488,
	"./main/models/bmcProgress.js": 488,
	"./main/models/channel": 337,
	"./main/models/channel.js": 337,
	"./main/models/chatGroup": 491,
	"./main/models/chatGroup.js": 491,
	"./main/models/common": 329,
	"./main/models/common.js": 329,
	"./main/models/competitor": 344,
	"./main/models/competitor.js": 344,
	"./main/models/connection": 484,
	"./main/models/connection.js": 484,
	"./main/models/cost": 339,
	"./main/models/cost.js": 339,
	"./main/models/customerSegment": 338,
	"./main/models/customerSegment.js": 338,
	"./main/models/financialFile": 353,
	"./main/models/financialFile.js": 353,
	"./main/models/getKeepGrow": 336,
	"./main/models/getKeepGrow.js": 336,
	"./main/models/ideation": 345,
	"./main/models/ideation.js": 345,
	"./main/models/keyActivity": 333,
	"./main/models/keyActivity.js": 333,
	"./main/models/keyPartner": 332,
	"./main/models/keyPartner.js": 332,
	"./main/models/keyResource": 334,
	"./main/models/keyResource.js": 334,
	"./main/models/message": 490,
	"./main/models/message.js": 490,
	"./main/models/notification": 208,
	"./main/models/notification.js": 208,
	"./main/models/portfolio": 348,
	"./main/models/portfolio.js": 348,
	"./main/models/portfolioFile": 349,
	"./main/models/portfolioFile.js": 349,
	"./main/models/portfolioStyle": 352,
	"./main/models/portfolioStyle.js": 352,
	"./main/models/portfolioTeammate": 350,
	"./main/models/portfolioTeammate.js": 350,
	"./main/models/portfolioTemplate": 351,
	"./main/models/portfolioTemplate.js": 351,
	"./main/models/product": 342,
	"./main/models/product.js": 342,
	"./main/models/progress": 427,
	"./main/models/progress/": 427,
	"./main/models/progress/channel": 752,
	"./main/models/progress/channel.js": 752,
	"./main/models/progress/cost": 754,
	"./main/models/progress/cost.js": 754,
	"./main/models/progress/costRevenue": 757,
	"./main/models/progress/costRevenue.js": 757,
	"./main/models/progress/customerSegment": 751,
	"./main/models/progress/customerSegment.js": 751,
	"./main/models/progress/gkg": 753,
	"./main/models/progress/gkg.js": 753,
	"./main/models/progress/ideation": 371,
	"./main/models/progress/ideation.js": 371,
	"./main/models/progress/index": 427,
	"./main/models/progress/index.js": 427,
	"./main/models/progress/keyThings": 546,
	"./main/models/progress/keyThings.js": 546,
	"./main/models/progress/revenue": 756,
	"./main/models/progress/revenue.js": 756,
	"./main/models/progress/sustainability": 755,
	"./main/models/progress/sustainability.js": 755,
	"./main/models/progress/testing": 288,
	"./main/models/progress/testing.js": 288,
	"./main/models/progress/valueProposition": 750,
	"./main/models/progress/valueProposition.js": 750,
	"./main/models/revenue": 341,
	"./main/models/revenue.js": 341,
	"./main/models/sustainability": 340,
	"./main/models/sustainability.js": 340,
	"./main/models/testDocument": 347,
	"./main/models/testDocument.js": 347,
	"./main/models/testing": 346,
	"./main/models/testing.js": 346,
	"./main/models/uniqueSellingPoint": 343,
	"./main/models/uniqueSellingPoint.js": 343,
	"./main/models/user": 209,
	"./main/models/user.js": 209,
	"./main/models/valueProposition": 335,
	"./main/models/valueProposition.js": 335,
	"./main/rematcher/store": 95,
	"./main/rematcher/store.js": 95,
	"./main/utils/GlobalContext": 31,
	"./main/utils/GlobalContext.js": 31,
	"./main/utils/Router": 135,
	"./main/utils/Router.js": 135,
	"./main/utils/appRoutes": 45,
	"./main/utils/appRoutes.js": 45,
	"./main/utils/axios": 301,
	"./main/utils/axios.js": 301,
	"./main/utils/const": 1,
	"./main/utils/const.js": 1,
	"./main/utils/factories": 468,
	"./main/utils/factories/": 468,
	"./main/utils/factories/bmcBlocks": 92,
	"./main/utils/factories/bmcBlocks.js": 92,
	"./main/utils/factories/chatGroups": 202,
	"./main/utils/factories/chatGroups.js": 202,
	"./main/utils/factories/costPriceOptions": 139,
	"./main/utils/factories/costPriceOptions.js": 139,
	"./main/utils/factories/customerSegment": 266,
	"./main/utils/factories/customerSegment.js": 266,
	"./main/utils/factories/documentTypes": 330,
	"./main/utils/factories/documentTypes.js": 330,
	"./main/utils/factories/index": 468,
	"./main/utils/factories/index.js": 468,
	"./main/utils/factories/moment": 486,
	"./main/utils/factories/moment.js": 486,
	"./main/utils/factories/portfolioTemplate": 489,
	"./main/utils/factories/portfolioTemplate.js": 489,
	"./main/utils/factories/testStatus": 204,
	"./main/utils/factories/testStatus.js": 204,
	"./main/utils/factories/testTypes": 519,
	"./main/utils/factories/testTypes.js": 519,
	"./main/utils/factories/userRoles": 302,
	"./main/utils/factories/userRoles.js": 302,
	"./main/utils/generatorPassword": 504,
	"./main/utils/generatorPassword.js": 504,
	"./main/utils/helpers": 8,
	"./main/utils/helpers.js": 8,
	"./main/utils/helpers/": 1138,
	"./main/utils/helpers/calculations": 632,
	"./main/utils/helpers/calculations.js": 632,
	"./main/utils/helpers/collection": 633,
	"./main/utils/helpers/collection.js": 633,
	"./main/utils/helpers/components": 634,
	"./main/utils/helpers/components.js": 634,
	"./main/utils/helpers/copyToClipboard": 498,
	"./main/utils/helpers/copyToClipboard.js": 498,
	"./main/utils/helpers/customerSegment": 261,
	"./main/utils/helpers/customerSegment.js": 261,
	"./main/utils/helpers/formatNumber": 601,
	"./main/utils/helpers/formatNumber.js": 601,
	"./main/utils/helpers/getActiveTabColor": 1393,
	"./main/utils/helpers/getActiveTabColor.js": 1393,
	"./main/utils/helpers/getColorDependsOnBackground": 24,
	"./main/utils/helpers/getColorDependsOnBackground.js": 24,
	"./main/utils/helpers/getColorTemplate": 106,
	"./main/utils/helpers/getColorTemplate.js": 106,
	"./main/utils/helpers/getCurrentCanvasIcon": 82,
	"./main/utils/helpers/getCurrentCanvasIcon.js": 82,
	"./main/utils/helpers/getCurrentSubtitleColor": 198,
	"./main/utils/helpers/getCurrentSubtitleColor.js": 198,
	"./main/utils/helpers/getImageAspectRatio": 83,
	"./main/utils/helpers/getImageAspectRatio.js": 83,
	"./main/utils/helpers/getIndexColor": 197,
	"./main/utils/helpers/getIndexColor.js": 197,
	"./main/utils/helpers/getOptionsChart": 878,
	"./main/utils/helpers/getOptionsChart.js": 878,
	"./main/utils/helpers/getPortfolioShortCuts": 30,
	"./main/utils/helpers/getPortfolioShortCuts.js": 30,
	"./main/utils/helpers/getRenderBlockGKG": 728,
	"./main/utils/helpers/getRenderBlockGKG.js": 728,
	"./main/utils/helpers/getStar": 598,
	"./main/utils/helpers/getStar.js": 598,
	"./main/utils/helpers/getSvgGKGTabs": 727,
	"./main/utils/helpers/getSvgGKGTabs.js": 727,
	"./main/utils/helpers/getTitleStyle": 518,
	"./main/utils/helpers/getTitleStyle.js": 518,
	"./main/utils/helpers/image": 635,
	"./main/utils/helpers/image.js": 635,
	"./main/utils/helpers/index": 1138,
	"./main/utils/helpers/index.js": 1138,
	"./main/utils/helpers/isSecondOrThirdTemplate": 108,
	"./main/utils/helpers/isSecondOrThirdTemplate.js": 108,
	"./main/utils/helpers/maps": 636,
	"./main/utils/helpers/maps.js": 636,
	"./main/utils/helpers/menu": 637,
	"./main/utils/helpers/menu.js": 637,
	"./main/utils/helpers/nextComponentHandlerFunction": 277,
	"./main/utils/helpers/nextComponentHandlerFunction.js": 277,
	"./main/utils/helpers/object": 638,
	"./main/utils/helpers/object.js": 638,
	"./main/utils/helpers/portfolioArchTemplate/getColorDependsOnBackgroundAndPalette": 102,
	"./main/utils/helpers/portfolioArchTemplate/getColorDependsOnBackgroundAndPalette.js": 102,
	"./main/utils/helpers/portfolioArchTemplate/getStylesDependsOnBackgroundAndPalleteChannels": 525,
	"./main/utils/helpers/portfolioArchTemplate/getStylesDependsOnBackgroundAndPalleteChannels.js": 525,
	"./main/utils/helpers/portfolioCurrentTemplate/getColorDependsOnBackgroundSummary": 279,
	"./main/utils/helpers/portfolioCurrentTemplate/getColorDependsOnBackgroundSummary.js": 279,
	"./main/utils/helpers/renderImage": 68,
	"./main/utils/helpers/renderImage.js": 68,
	"./main/utils/helpers/renderLogo": 190,
	"./main/utils/helpers/renderLogo.js": 190,
	"./main/utils/helpers/renderSegmentList": 84,
	"./main/utils/helpers/renderSegmentList.js": 84,
	"./main/utils/helpers/renderText": 85,
	"./main/utils/helpers/renderText.js": 85,
	"./main/utils/helpers/select": 639,
	"./main/utils/helpers/select.js": 639,
	"./main/utils/helpers/text": 640,
	"./main/utils/helpers/text.js": 640,
	"./main/utils/icons": 88,
	"./main/utils/icons/": 88,
	"./main/utils/icons/index": 88,
	"./main/utils/icons/index.js": 88,
	"./main/utils/icons/sustainabilityIcons": 682,
	"./main/utils/icons/sustainabilityIcons.js": 682,
	"./main/utils/isElementVisible": 496,
	"./main/utils/isElementVisible.js": 496,
	"./main/utils/makeRequest": 17,
	"./main/utils/makeRequest.js": 17,
	"./main/utils/options/testStatusOptions": 1394,
	"./main/utils/options/testStatusOptions.js": 1394,
	"./main/utils/passwordValidation": 397,
	"./main/utils/passwordValidation.js": 397,
	"./main/utils/roles": 163,
	"./main/utils/roles.js": 163,
	"./main/utils/serverRoutes": 20,
	"./main/utils/serverRoutes.js": 20,
	"./onboarding": 641,
	"./onboarding/": 641,
	"./onboarding/OnboardingLayout": 368,
	"./onboarding/OnboardingLayout.js": 368,
	"./onboarding/PrivacyInformation/PrivacyInformation": 968,
	"./onboarding/PrivacyInformation/PrivacyInformation.js": 968,
	"./onboarding/Router": 990,
	"./onboarding/Router.js": 990,
	"./onboarding/forgotPassword": 480,
	"./onboarding/forgotPassword/": 480,
	"./onboarding/forgotPassword/ForgotPasswordForm": 996,
	"./onboarding/forgotPassword/ForgotPasswordForm.js": 996,
	"./onboarding/forgotPassword/index": 480,
	"./onboarding/forgotPassword/index.js": 480,
	"./onboarding/forgotPassword/validationSchema": 997,
	"./onboarding/forgotPassword/validationSchema.js": 997,
	"./onboarding/index": 641,
	"./onboarding/index.js": 641,
	"./onboarding/newPassword": 481,
	"./onboarding/newPassword/": 481,
	"./onboarding/newPassword/NewPasswordForm": 998,
	"./onboarding/newPassword/NewPasswordForm.js": 998,
	"./onboarding/newPassword/index": 481,
	"./onboarding/newPassword/index.js": 481,
	"./onboarding/newPassword/validationSchema": 999,
	"./onboarding/newPassword/validationSchema.js": 999,
	"./onboarding/signIn": 479,
	"./onboarding/signIn/": 479,
	"./onboarding/signIn/SigninForm": 993,
	"./onboarding/signIn/SigninForm.js": 993,
	"./onboarding/signIn/UpdatePasswordModal": 995,
	"./onboarding/signIn/UpdatePasswordModal.js": 995,
	"./onboarding/signIn/index": 479,
	"./onboarding/signIn/index.js": 479,
	"./onboarding/signIn/validationSchema": 994,
	"./onboarding/signIn/validationSchema.js": 994,
	"./onboarding/signUp": 478,
	"./onboarding/signUp/": 478,
	"./onboarding/signUp/Input": 125,
	"./onboarding/signUp/Input.js": 125,
	"./onboarding/signUp/OnboardingInfo": 967,
	"./onboarding/signUp/OnboardingInfo.js": 967,
	"./onboarding/signUp/SignupForm": 991,
	"./onboarding/signUp/SignupForm.js": 991,
	"./onboarding/signUp/index": 478,
	"./onboarding/signUp/index.js": 478,
	"./onboarding/signUp/initialFormValues": 992,
	"./onboarding/signUp/initialFormValues.js": 992,
	"./onboarding/signUp/validationSchema": 534,
	"./onboarding/signUp/validationSchema.js": 534,
	"./onboarding/signUpElevatedPrivilege": 482,
	"./onboarding/signUpElevatedPrivilege/": 482,
	"./onboarding/signUpElevatedPrivilege/index": 482,
	"./onboarding/signUpElevatedPrivilege/index.js": 482,
	"./onboarding/sso/SSOSigninSignUpForm": 369,
	"./onboarding/sso/SSOSigninSignUpForm.js": 369,
	"./onboarding/store": 1000,
	"./onboarding/store.js": 1000,
	"./portfolio/Portfolio": 1395,
	"./portfolio/Portfolio.js": 1395,
	"./portfolio/architecturalMinimalComponents/Channels": 1031,
	"./portfolio/architecturalMinimalComponents/Channels.js": 1031,
	"./portfolio/architecturalMinimalComponents/ContactUs": 1032,
	"./portfolio/architecturalMinimalComponents/ContactUs.js": 1032,
	"./portfolio/architecturalMinimalComponents/CustomerSegment": 1029,
	"./portfolio/architecturalMinimalComponents/CustomerSegment.js": 1029,
	"./portfolio/architecturalMinimalComponents/Introduction": 1026,
	"./portfolio/architecturalMinimalComponents/Introduction.js": 1026,
	"./portfolio/architecturalMinimalComponents/Summary": 1027,
	"./portfolio/architecturalMinimalComponents/Summary.js": 1027,
	"./portfolio/architecturalMinimalComponents/Team": 1028,
	"./portfolio/architecturalMinimalComponents/Team.js": 1028,
	"./portfolio/architecturalMinimalComponents/ValueProposition": 1030,
	"./portfolio/architecturalMinimalComponents/ValueProposition.js": 1030,
	"./portfolio/blogFriendlyComponents/Channels": 1023,
	"./portfolio/blogFriendlyComponents/Channels.js": 1023,
	"./portfolio/blogFriendlyComponents/ContactUs": 1024,
	"./portfolio/blogFriendlyComponents/ContactUs.js": 1024,
	"./portfolio/blogFriendlyComponents/CustomerSegment": 1021,
	"./portfolio/blogFriendlyComponents/CustomerSegment.js": 1021,
	"./portfolio/blogFriendlyComponents/Introduction": 1018,
	"./portfolio/blogFriendlyComponents/Introduction.js": 1018,
	"./portfolio/blogFriendlyComponents/Summary": 1019,
	"./portfolio/blogFriendlyComponents/Summary.js": 1019,
	"./portfolio/blogFriendlyComponents/Team": 1020,
	"./portfolio/blogFriendlyComponents/Team.js": 1020,
	"./portfolio/blogFriendlyComponents/ValueProposition": 1022,
	"./portfolio/blogFriendlyComponents/ValueProposition.js": 1022,
	"./portfolio/boldComponents/ChannelsBoldWeb": 1057,
	"./portfolio/boldComponents/ChannelsBoldWeb.js": 1057,
	"./portfolio/boldComponents/ContactUsBoldWeb": 1058,
	"./portfolio/boldComponents/ContactUsBoldWeb.js": 1058,
	"./portfolio/boldComponents/CustomerSegmentBoldWeb": 1055,
	"./portfolio/boldComponents/CustomerSegmentBoldWeb.js": 1055,
	"./portfolio/boldComponents/IntroductionBoldWeb": 1052,
	"./portfolio/boldComponents/IntroductionBoldWeb.js": 1052,
	"./portfolio/boldComponents/SummaryBoldWeb": 1053,
	"./portfolio/boldComponents/SummaryBoldWeb.js": 1053,
	"./portfolio/boldComponents/TeamBoldWeb": 1054,
	"./portfolio/boldComponents/TeamBoldWeb.js": 1054,
	"./portfolio/boldComponents/ValuePropositionBoldWeb": 1056,
	"./portfolio/boldComponents/ValuePropositionBoldWeb.js": 1056,
	"./portfolio/colourfulComponents/Channels": 1015,
	"./portfolio/colourfulComponents/Channels.js": 1015,
	"./portfolio/colourfulComponents/ContactUs": 1016,
	"./portfolio/colourfulComponents/ContactUs.js": 1016,
	"./portfolio/colourfulComponents/CustomerSegment": 1013,
	"./portfolio/colourfulComponents/CustomerSegment.js": 1013,
	"./portfolio/colourfulComponents/Introduction": 1010,
	"./portfolio/colourfulComponents/Introduction.js": 1010,
	"./portfolio/colourfulComponents/Summary": 1011,
	"./portfolio/colourfulComponents/Summary.js": 1011,
	"./portfolio/colourfulComponents/Team": 1012,
	"./portfolio/colourfulComponents/Team.js": 1012,
	"./portfolio/colourfulComponents/ValueProposition": 1014,
	"./portfolio/colourfulComponents/ValueProposition.js": 1014,
	"./portfolio/containers/ArchitecturalMinimalTemplate": 1025,
	"./portfolio/containers/ArchitecturalMinimalTemplate.js": 1025,
	"./portfolio/containers/BlogFriendlyTemplate": 1017,
	"./portfolio/containers/BlogFriendlyTemplate.js": 1017,
	"./portfolio/containers/BoldTemplateWeb": 1051,
	"./portfolio/containers/BoldTemplateWeb.js": 1051,
	"./portfolio/containers/ColourfulFunWebTemplate": 1009,
	"./portfolio/containers/ColourfulFunWebTemplate.js": 1009,
	"./portfolio/containers/CurrentWebTemplate": 1001,
	"./portfolio/containers/CurrentWebTemplate.js": 1001,
	"./portfolio/containers/Portfolio": 603,
	"./portfolio/containers/Portfolio.js": 603,
	"./portfolio/containers/TechModernTemplateWeb": 1033,
	"./portfolio/containers/TechModernTemplateWeb.js": 1033,
	"./portfolio/currentComponents/Channels": 1007,
	"./portfolio/currentComponents/Channels.js": 1007,
	"./portfolio/currentComponents/ContactUs": 1008,
	"./portfolio/currentComponents/ContactUs.js": 1008,
	"./portfolio/currentComponents/CustomerSegment": 1005,
	"./portfolio/currentComponents/CustomerSegment.js": 1005,
	"./portfolio/currentComponents/Introduction": 1002,
	"./portfolio/currentComponents/Introduction.js": 1002,
	"./portfolio/currentComponents/Summary": 1003,
	"./portfolio/currentComponents/Summary.js": 1003,
	"./portfolio/currentComponents/Team": 1004,
	"./portfolio/currentComponents/Team.js": 1004,
	"./portfolio/currentComponents/ValueProposition": 1006,
	"./portfolio/currentComponents/ValueProposition.js": 1006,
	"./portfolio/mainWebTemplateComponents/BMC": 230,
	"./portfolio/mainWebTemplateComponents/BMC.js": 230,
	"./portfolio/mainWebTemplateComponents/CompetitorAnalysis": 232,
	"./portfolio/mainWebTemplateComponents/CompetitorAnalysis.js": 232,
	"./portfolio/mainWebTemplateComponents/Desirability": 237,
	"./portfolio/mainWebTemplateComponents/Desirability.js": 237,
	"./portfolio/mainWebTemplateComponents/Feasibility": 238,
	"./portfolio/mainWebTemplateComponents/Feasibility.js": 238,
	"./portfolio/mainWebTemplateComponents/Finance": 234,
	"./portfolio/mainWebTemplateComponents/Finance.js": 234,
	"./portfolio/mainWebTemplateComponents/GKG": 233,
	"./portfolio/mainWebTemplateComponents/GKG.js": 233,
	"./portfolio/mainWebTemplateComponents/KeyActivities": 236,
	"./portfolio/mainWebTemplateComponents/KeyActivities.js": 236,
	"./portfolio/mainWebTemplateComponents/Sustainability": 235,
	"./portfolio/mainWebTemplateComponents/Sustainability.js": 235,
	"./portfolio/mainWebTemplateComponents/Testing": 231,
	"./portfolio/mainWebTemplateComponents/Testing.js": 231,
	"./portfolio/mainWebTemplateComponents/Viability": 239,
	"./portfolio/mainWebTemplateComponents/Viability.js": 239,
	"./portfolio/rematcher/store": 1059,
	"./portfolio/rematcher/store.js": 1059,
	"./portfolio/techModernComponents/BMC": 1037,
	"./portfolio/techModernComponents/BMC.js": 1037,
	"./portfolio/techModernComponents/ChannelsTechWeb": 1043,
	"./portfolio/techModernComponents/ChannelsTechWeb.js": 1043,
	"./portfolio/techModernComponents/CompetitorAnalysisTechWeb": 1041,
	"./portfolio/techModernComponents/CompetitorAnalysisTechWeb.js": 1041,
	"./portfolio/techModernComponents/ContactUsTechWeb": 1047,
	"./portfolio/techModernComponents/ContactUsTechWeb.js": 1047,
	"./portfolio/techModernComponents/CustomerSegment": 1039,
	"./portfolio/techModernComponents/CustomerSegment.js": 1039,
	"./portfolio/techModernComponents/Desirability": 1048,
	"./portfolio/techModernComponents/Desirability.js": 1048,
	"./portfolio/techModernComponents/Feasibility": 1050,
	"./portfolio/techModernComponents/Feasibility.js": 1050,
	"./portfolio/techModernComponents/FinanceTechWeb": 1045,
	"./portfolio/techModernComponents/FinanceTechWeb.js": 1045,
	"./portfolio/techModernComponents/GKG": 1042,
	"./portfolio/techModernComponents/GKG.js": 1042,
	"./portfolio/techModernComponents/IntroductionTechWeb": 1034,
	"./portfolio/techModernComponents/IntroductionTechWeb.js": 1034,
	"./portfolio/techModernComponents/KeyActivitiesTechWeb": 1044,
	"./portfolio/techModernComponents/KeyActivitiesTechWeb.js": 1044,
	"./portfolio/techModernComponents/SummaryTechWeb": 1035,
	"./portfolio/techModernComponents/SummaryTechWeb.js": 1035,
	"./portfolio/techModernComponents/SustainAbilityTechWeb": 1046,
	"./portfolio/techModernComponents/SustainAbilityTechWeb.js": 1046,
	"./portfolio/techModernComponents/TeamTechWeb": 1036,
	"./portfolio/techModernComponents/TeamTechWeb.js": 1036,
	"./portfolio/techModernComponents/Testing": 1038,
	"./portfolio/techModernComponents/Testing.js": 1038,
	"./portfolio/techModernComponents/ValuePropositionTechWeb": 1040,
	"./portfolio/techModernComponents/ValuePropositionTechWeb.js": 1040,
	"./portfolio/techModernComponents/Viability": 1049,
	"./portfolio/techModernComponents/Viability.js": 1049,
	"./sso": 642,
	"./sso/": 642,
	"./sso/Router": 1061,
	"./sso/Router.js": 1061,
	"./sso/index": 642,
	"./sso/index.js": 642,
	"./sso/store": 1060,
	"./sso/store.js": 1060,
	"./sso/userSelect": 483,
	"./sso/userSelect/": 483,
	"./sso/userSelect/index": 483,
	"./sso/userSelect/index.js": 483,
	"./sso/userSelect/user/UserCard": 1062,
	"./sso/userSelect/user/UserCard.js": 1062,
	"./sso/userSelect/user/UserSvg": 1063,
	"./sso/userSelect/user/UserSvg.js": 1063,
	"./test": 643,
	"./test/": 643,
	"./test/Components/Landing1": 1065,
	"./test/Components/Landing1.js": 1065,
	"./test/Components/Landing2": 1066,
	"./test/Components/Landing2.js": 1066,
	"./test/Components/Landing3": 1067,
	"./test/Components/Landing3.js": 1067,
	"./test/Components/Landing4": 1068,
	"./test/Components/Landing4.js": 1068,
	"./test/Containers/Test": 1064,
	"./test/Containers/Test.js": 1064,
	"./test/index": 643,
	"./test/index.js": 643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1468;